






















































































































































































































































































































































































































































































































































































































































































































































































































































































import dayJs from 'dayjs';
import { openList, openSelectList } from '@/main/router/routerPath';
import { editFactory } from '@/main/pages';
import { ReklamaText } from '@/modules/ciselnik/firemni/reklamaText';
import { DropdownItem, Platba } from '@/main/store/@types/dropdown.d';
import _ from 'lodash';
import { getBoundary, parseMultipart } from '@/main/services/multiPartProvider';
import { showAlert } from '@/main/utils/notifications';

import { apiProvider as reverJobOrderApi } from '@/modules/servis/zakazka/ReverseJobOrder/api';

import { apiProvider as pratnerApiProvider } from '@/modules/kartoteka/partner/api';

import { apiProvider as orderApiProvider } from '@/modules/servis/zakazka/api';

import { apiProvider as partReturnsApiProvider } from '@/modules/servis/zakazka/PartReturnRequest/api';

import { ZAKAZKA_STAV, ZAKAZKA_DRUH } from '@/modules/servis/zakazka/constants';
import DropButtons from '@/modules/servis/zakazka/components/DropButtons.vue';

import { ScreenSize } from '@/main/components/constants';

import { formatDate } from '@/main/utils/dateFormatter';

import { SPLIT_PARTIES } from '@/modules/servis/zakazka/SplitBilling/constants';

import DmsPdfDialog from '#components/DmsPdfDialog.vue';
import { getNextStavZakazka, getPrevStavZakazka, getStavZakazka } from '@/modules/servis/zakazka/utils';


import { editMutations } from './store/types';
import {
	DokladNaplnFakturaci, NAME, PlatbaTyp, TypPrijemceFaktury, REPORT_TYPE, ApproverStatus,
	PRIMARY_CUSTOMER_SPLIT_INDEX, EGUI_OPTIONS, MENU_CODE, BILLING_OPERATION_CODE, EGUI_TRANS_OPTIONS, EGUI_TYPES, IPartialInvoice,
	EGUI_PAYMENT_VALIDATION, IeGUISplitOptions 
} from './constants';
import { SplitPartyType } from '../../servis/zakazka/SplitBilling/store/SplitBillingDetails';
import { apiProvider } from './api';

import { store } from './store/edit';
import { Fakturace } from '.';
import { START_LOADING } from '@/main/store/listEditTypes';
import { isRouteEvent, RouteEvent } from '@/main/pages/page';



export default editFactory(NAME, store).extend({
	components: {
		DmsPdfDialog,
		DropButtons,
	},
	data() {
		return {
			lstRevOrdersButtons: [
				{
					labelKey: '' as string | null,
					click: '' as string | null,
					param: false as boolean | null,
					disable: '' as string | boolean | null,
					exist: true as boolean | null,
					icon: '' as string | null,
					text: '' as string | null,
				},
			],
			screenSize: ScreenSize.TABLET,
			windowWidth: window.innerWidth,
			showRejectedReasonsDialog: false,
			tiskDialog: {
				visible: false as boolean | null,
				url: null as string | null,
				filter: null as Record<string, any> | null,
				fetchPdfProvider: null as ((filter: {}) => Promise<any>) | null,
				dialogClosed: () => { },
			},
			oemApprovaldata: {
				data: false,
			},
			isMarkAsPrint: false as boolean | null,
			reportType: '' as string,
			iseGUIApplicable: false,
			iseGUIVisible: false,
			lbleGUI: 'EGUI',
			iseGUIIssuePopUpVisible: false,
			rdbCarrier: '' as string | null,
			rdbEcpayCarrier: '' as string | null,
			barCode: '' as string | null,
			digitalCertificate: '' as string | null,
			loveCode: '' as string | null,
			isCreditNoteApproved: false as boolean | null,
			isEguiCancelPopupVisible: false,
			cancelEGUItxt: true,
			cancelInvoiceTxt: EGUI_OPTIONS.EGUI_CANCEL,
			invoiceRemark: '' as string,
			isSagaProcessed: false as boolean | null,
			defaultCustomerIdentifier: '' as string | null,
			isEguiCanceled: true as boolean | null,
			ownCarrier: '0' as string | null,
			eCpayCarrier: '1' as string | null,
			barCodeCarrier: '3' as string | null,
			certificateCarrier: '2' as string | null,
			donateCarrier: '4' as string | null,
			cinCarrier: '5' as string | null,
			eguiSuccessCode: 1 as number | null,
			isBarcodeValid: 'Y' as string | null,
			seperateLabourItem: this.LocalizePopisPoli('SEPERATELABOURITEM') as string | null,
			seperateLabourItemSecond: this.LocalizePopisPoli('SEPERATELABOURITEM') as string | null,
			seperateItem: this.LocalizePopisPoli('SEPERATELABOURITEM'),
			combineItem: this.LocalizePopisPoli('COMBINELABOURITEM'),
			isApproveButtonClicked: false,
			isRejectButtonClicked: false,
			isBillingButtonClicked: false,
			iseGUITypeCompany: false,
			iseGUITypeWithCarrier: false,
			iseGUITypeNoCarrier: false,
			AdvanceTotalPayment: 0 as number,
			ActualTotalPayment: 0 as number,
			isCommonPayment: false,
			isSplitAllowed: false,
			arrayeGUISplitDetails: [] as any[],
			isCINSplitSelected: false,
			isBarCodeSplitSelected: false,
			isCertificateSplitSelected: false,
 			isLoveCodeSplitSelected: false,
			eGUISplitPartyTypeIdForNoCarrier: 999,
			isPrevItemRemoved: true,
			isPaymentMethodApplicable: false,
			isSelectAllVisible: false,
			mainCollapse: ['1', '2'],
			isShoweGUISummary: false,
			isSplitEligible: false,
			rdbCarrierSecond: '' as string | null,
			rdbEcpayCarrierSecond: '' as string | null,
			paytotal: 0 as number,
			paytotalSecond: 0 as number,
			iseGUITypeCompanySecond: false,
			iseGUITypeWithCarrierSecond: false,
			iseGUITypeNoCarrierSecond: false,
			isCINSplitSelectedSecond: false,
			isBarCodeSplitSelectedSecond: false,
			isCertificateSplitSelectedSecond: false,
 			isLoveCodeSplitSelectedSecond: false,
			barCodeSecond: '' as string | null,
			digitalCertificateSecond: '' as string | null,
			loveCodeSecond: '' as string | null,
			invoiceRemarkSecond: '' as string,
			showPolicyDialog: false,
			insurancePolicyDetails: 100,
			isSplited: true,
			SecondEGUISplitAmount: 0,
			FirstEGUISplitAmount: 0,
			TotalInvoiceAmount: 0,
			FirstLaborAmount: 0,
			PartsTotalAmount: 0,
			LaborTotalAmount: 0,
			TotalDeductions: 0,
			RoundOff: null as number | null,
			HandlingFee: null as number | null,
			VgtDeduction: null as number | null,
			DealerDeduction: null as number | null,
			FirstEGUIPartsAmount: null as number | null,
			FirstEGUILaborAmount: null as number | null,
			SecondEGUIPartsAmount: 0,
			SecondEGUILaborAmount: 0,
			TotalFirstEGUIPartsAmount: 0,
			TotalFirstEGUILaborAmount: 0,
			barCodeCarrierSecond: '6' as string | null,
			certificateCarrierSecond: '9' as string | null,
			donateCarrierSecond: '8' as string | null,
			cinCarrierSecond: '10' as string | null,
			firstEguiCustomerName: '' as string,
			secondEguiCustomerName: '' as string,
			sagaStatusMessage: '',
			isProceedClicked: false,
			SelectedPartialInvoice: [] as IPartialInvoice[] | null,
			isSplitEGUI:false,
		};
	},
	computed: {
		mutationsMappers(): Record<string, string> {
			return {
				pojistovna: `${this.storeUri}/${editMutations.FAKTURACE_POJISTOVNA_SELECT_MAPPER}`,
				jinyPrijemce: `${this.storeUri}/${editMutations.FAKTURACE_JINY_PRIJEMCE_SELECT_MAPPER}`,
				leasZakaznik: `${this.storeUri}/${editMutations.FAKTURACE_LEAS_ZAKAZNIK_SELECT_MAPPER}`,
			};
		},
		pracovniPoziceName(): string {
			return NAME;
		},
		eGUIActions(): any {
			if ((this.lbleGUI === 'EGUI' || this.lbleGUI === 'issueInvoice') && !this.isCreditNote) {
				return {
					issueInvoice: 'EGUI_ISSUE',
				};
			}
			return {
				cancelInvoice: 'EGUI_CANCEL',
			};
		},
		isEguiOptionsVisible(): boolean {
			return this.lbleGUI === 'issueInvoice';
		},
		layoutProps(): {} {
			return {
				operations: 0,
				mode: this.pageMode,
				saveClick: () => {},
				deleteClick: () => {},
				closeClick: this.closeClick,
				model: this.edit,
				validationRules: this.validationRulesCmp,
				isModified: this.isModified,
			};
		},
		isApproveRejectClicked(): boolean {
			if(this.isApproveButtonClicked){
				return true;
			}
			if(this.isRejectButtonClicked){
				return true;
			}
			return false;
		},
		isReverseJobOrderVisible(): boolean {
			let flag = false;
			if (this.props.filter.isapprover) {
				flag = true;
			}
			if (this.props.filter.statusId === ApproverStatus.APPROVE) {
				flag = false;
			}
			if (this.props.filter.statusId === -ApproverStatus.SUBMITTED)	{
				flag = true;
			}
			if (this.props.filter.statusId === ApproverStatus.REJECT)	{
				flag = false;
			}
			return flag;
		},
		isBezPlatby(): boolean {
			return this.isNabidka && this.PlatbaPzn === PlatbaTyp.DONT_PAY;
		},
		isPovFaktura(): boolean {
			return !_.isNil(this.props.filter.povId);
		},
		platba(): Platba | undefined {
			return this.dropdownList.PlatbaPzn ? this.dropdownList.PlatbaPzn.find((item) => item.Value === this.PlatbaPzn) : undefined;
		},
		isCiziMena(): boolean {
			return this.platba ? this.platba.CizimenaPrp : false;
		},
		menaId(): number | null {
			return this.isCiziMena ? this.MenaId2 : this.PrimarniMenaOrganizace;
		},
		isEnabledUserPokladna(): boolean {
			return this.dropdownList.PokladnaId.some((item: any) => item.Value === this.UzivatelDefaultPokladnaId && item.Disabled === false);
		},
		PokladnaIdFiltered(): DropdownItem[] {
			if (!this.menaId) return this.dropdownList.PokladnaId;
			return this.dropdownList.PokladnaId.filter((item: any) => item.MenaId === this.menaId);
		},
		isPlatbaHlavnaPokladna(): boolean {
			return ![PlatbaTyp.CASH, PlatbaTyp.CREDIT_CARD, PlatbaTyp.POSTAL_CARD].includes(this.PlatbaPzn!);
		},
		isPlatbaCiziMenou(): boolean {
			return this.PlatbaPzn === PlatbaTyp.FOREIGN_CURRENCY;
		},
		isEmptyorDefault(): boolean {
			if (this.dmsSys.BillingPrp) {
				return this.platba === null || this.PlatbaPzn === PlatbaTyp.CHEQUE;
			}
			return this.platba === null || this.PlatbaPzn === PlatbaTyp.DONT_PAY;
		},
		isDuzpEnabled(): boolean {
			return !this.IsOprava && !this.isVrubopis && !this.isEmptyorDefault;
		},
		isSplatnostDateEnabled(): boolean {
			return this.isPlatbaHlavnaPokladna && !this.isEmptyorDefault && !!this.platba?.SplatnostPrp;
		},
		isSplatnostDobaEnabled(): boolean {
			return !!(this.platba && this.platba.SplatnostPrp && !this.IsOprava && this.HasPermissionSplatnost);
		},
		isSplatnostDobaVisible(): boolean {
			return !!(
				this.platba
				&& this.platba.SplatnostPrp
				&& !this.IsOprava
				&& this.isPlatbaHlavnaPokladna
				&& this.PlatbaPzn === PlatbaTyp.NET_BANKING
				&& !this.isNabidka
			);
		},
		is1DD(): boolean {
			return this.DokladNaplnFakturaci === DokladNaplnFakturaci.PRVNI_DD;
		},
		isNabidka(): boolean {
			return this.DokladNaplnFakturaci === DokladNaplnFakturaci.NABIDKA;
		},
		isCreditNote(): boolean {
			return this.DokladNaplnFakturaci === DokladNaplnFakturaci.DOBROPIS;
		},
		isPokladnaVisible(): boolean {
			return (
				(this as any).getDmsSysValue('PokladnaPrp', false)
				&& [PlatbaTyp.CASH, PlatbaTyp.CREDIT_CARD, PlatbaTyp.FOREIGN_CURRENCY].includes(this.PlatbaPzn!)
				&& this.props.filter.dokladNaplnFakturaci !== DokladNaplnFakturaci.PRO_FORMA
				&& this.props.filter.dokladNaplnFakturaci !== DokladNaplnFakturaci.REF_DOC
				&& !this.isNabidka
			);
		},
		isBankovniSpojeniEnabled(): boolean {
			return !!(this.platba && this.platba.BankuczmenaPrp);
		},
		isBankovniSpojeniVisible(): boolean {
			return !this.isEmptyorDefault && !!this.platba?.BankuczmenaPrp && this.PlatbaPzn !== PlatbaTyp.CREDIT_CARD && !this.isNabidka;
		},
		isDobropisDovodVisible(): boolean {
			return [
				DokladNaplnFakturaci.VRUBOPIS,
				DokladNaplnFakturaci.CASTECNY_DOBROPIS,
				DokladNaplnFakturaci.DOBROPIS,
				DokladNaplnFakturaci.POLOZKOVY_DOBROPIS,
			].includes(this.DokladNaplnFakturaci!);
		},
		isVrubopis(): boolean {
			return this.DokladNaplnFakturaci === DokladNaplnFakturaci.VRUBOPIS;
		},
		isProformaClicked(): boolean {
			if((this.DokladNaplnFakturaci === DokladNaplnFakturaci.PRO_FORMA || this.DokladNaplnFakturaci === DokladNaplnFakturaci.DRUHY_DD || this.DokladNaplnFakturaci === DokladNaplnFakturaci.REF_DOC)
			&& this.edit.ZakazkaStav === ZAKAZKA_STAV.UVOLNENA)
            {
             if(_.isUndefined(this.hasBillingPermission)) {
				 return false;
			 }
            }
			if (this.OrderType === ZAKAZKA_DRUH.PREVOD_ND) {
				return (this.DokladNaplnFakturaci === DokladNaplnFakturaci.DOBROPIS || this.edit.ZakazkaStav === ZAKAZKA_STAV.UVOLNENA);
			}
			return (this.DokladNaplnFakturaci === DokladNaplnFakturaci.DOBROPIS || (this.edit.IsProformaCreated && this.edit.ZakazkaStav === ZAKAZKA_STAV.UVOLNENA));
		},
		subjectSplatnostDoba(): { SplatnostDoba: TypPrijemceFaktury | null; PlatbaPzn: number | null } | null {
			switch (this.FakturaceSubject) {
				case TypPrijemceFaktury.ZAKAZNIK:
					return { SplatnostDoba: this.ZakaznikSplatnostDoba, PlatbaPzn: this.ZakaznikPlatbaPzn };
				case TypPrijemceFaktury.LEASING:
					return { SplatnostDoba: this.LeaszakaznikSplatnostDoba, PlatbaPzn: this.LeaszakaznikPlatbaPzn };
				case TypPrijemceFaktury.JINY_PRIJEMCE:
					return { SplatnostDoba: this.JinyPrijemceSplatnostDoba, PlatbaPzn: this.JinyPrijemcePlatbaPzn };
				case TypPrijemceFaktury.POISTOVNA:
					return { SplatnostDoba: this.PojistovnaSplatnostDoba, PlatbaPzn: this.PojistovnaPlatbaPzn };
				case TypPrijemceFaktury.DEALERSHIP:
					return { SplatnostDoba: this.ZakaznikSplatnostDoba, PlatbaPzn: this.ZakaznikPlatbaPzn };
				default:
					return null;
			}
		},
		today(): Date {
			return dayJs(new Date()).startOf('day').toDate();
		},

		orderButtons(): object {
			this.lstRevOrdersButtons =			[
				{ labelKey: 'cmdFakt', click: 'fakturuj', param: false, disable: !this.isProformaClicked, exist: true, icon: 'el-icon-check', text: '' },
				{ labelKey: 'cmdPreview', click: 'fakturuj', param: true, disable: false, exist: true, icon: '', text: '' },
				{ labelKey: '', click: 'reklamnyTextVyberClick', param: null, disable: false, exist: true, icon: 'el-icon-plus', text: this.Localize('REKLTXT_ID') },
				{ labelKey: 'btnApprove', click: 'approveReverseJobOrder', param: false, disable: this.isApproveRejectClicked, exist: this.isReverseJobOrderVisible, icon: 'el-icon-check', text: '' },
				{ labelKey: 'btnReject', click: 'showRejectedReasonsDialogForDD', param: null, disable: this.isApproveRejectClicked, exist: this.isReverseJobOrderVisible, icon: 'el-icon-check', text: '' },
				{ labelKey: 'btnInsuranceReport', click: 'printInsuranceBillReport', param: null, disable: false, exist: this.dmsSys.IndiaCFDPrp, icon: '', text: '' },
				{ labelKey: 'btnCustomerReport', click: 'printCustomerBillReport', param: null, disable: false, exist: this.dmsSys.IndiaCFDPrp, icon: '', text: '' },
				{ labelKey: 'btnCustomerSalesInvoiceReport', click: 'printCustomerSalesInvoiceReport', param: null, disable: false, exist: this.dmsSys.IndiaCFDPrp, icon: '', text: '' },
				{ labelKey: 'btnWarrantyInvoiceReport', click: 'printWarrantyInvoiceReport', param: null, disable: false, exist: this.dmsSys.IndiaCFDPrp, icon: '', text: '' },
				{ labelKey: 'PrintCustSatiNote', click: 'onPrintCustomerSatisfactiontNote', param: null, disable: false, exist: this.dmsSys.IndiaCFDPrp, icon: '', text: '' },

			];

			return this.lstRevOrdersButtons
				.filter((item) => ((item?.labelKey !== undefined && item?.labelKey != null) || (item?.text !== undefined && item?.text != null)) && item?.exist)
				.map((item) => ({
					labelKey: item?.labelKey,
					click: () => { this.call(item?.click, item?.param); },
					exist: item?.exist,
					disable: item?.disable,
					icon: item?.icon,
					text: item?.text,
				}));
		},
		isTabletEnabled(): boolean {
			return this.windowWidth > this.screenSize;
		},
		isSplitPartyBillingEligible(): boolean {
			return (this.OrderType === ZAKAZKA_DRUH.PRODEJ_ZBOZI || this.OrderType === ZAKAZKA_DRUH.DILENSKA);
		},
		isAllSplitPartiesInvoiced(): boolean {
			return this.isSplitPartyBillingEligible && this.combinedSplitParties.every(x => x.IsBilled);
		},
		isDocumentGenerated(): boolean {
			return this.props.filter.dokladId === null || this.props.filter.dokladId === undefined || this.props.filter.dokladId < 0;
		},
		isNotProforma(): boolean {
			return (!this.nahled && this.DokladNaplnFakturaci !== DokladNaplnFakturaci.PRO_FORMA
			&& this.DokladNaplnFakturaci !== DokladNaplnFakturaci.QUICK_ESTIMATE);
		},
		isEGUIPopupVisible(): boolean {
			return this.iseGUIVisible || (this.isEguiCancelPopupVisible && this.EGUIInvoiceNumber !== '' && this.EGUIInvoiceNumber !== null);
		},
		isEGUIOptionAvailable(): boolean {
			if (this.OrderType === ZAKAZKA_DRUH.PRODEJ_ZBOZI && this.isEguiVisibleforOrders(this.combinedSplitParties)) {
				return true;
			} else if (this.OrderType === ZAKAZKA_DRUH.PRODEJ_PULT && this.isEguiVisibleforOrders(this.combinedSplitParties)) {
				return true;
			} else if (this.OrderType !== ZAKAZKA_DRUH.GARANCE && this.OrderType !== ZAKAZKA_DRUH.KULANCE
			&& this.OrderType !== ZAKAZKA_DRUH.PREVOD_ND && this.isEguiVisibleforOrders(this.combinedSplitParties)) {
				return true;
			} else {
				return false;
			}
		},
		isOkDisabled(): boolean {
			if (this.isEguiCancelPopupVisible && this.CancelInvoicedNo == null) return true;
			return false;
		},
		onChangeCancelEGUItxt(): boolean {
			return this.cancelEGUItxt;
		},
		isCanceledVisible(): boolean {
			return this.OrderType !== ZAKAZKA_DRUH.PRODEJ_PULT;
		},
		getEguiNumber(): string | null {
			return this.isEguiCancelPopupVisible && this.EguiSelectedPaymentMethod != null ? this.EGUISelectedInvoiceNumber : this.EGUIInvoiceNumber;
		},
		isCinDisabled(): boolean {
			return this.rdbCarrier != this.cinCarrier;
		},
		isInvoiceOptionVisible(): boolean {
			return this.rdbEcpayCarrier == this.ownCarrier;
		},
		getEguiDisplayOption() : any {
			return [this.seperateItem, this.combineItem];
		},
		hasBillingPermission():boolean {
			let result= this.loggedUser.UserMenu.find((menu: any) => menu.MenuCode === MENU_CODE
			&& menu.OperationCode.find((code: string) => code === BILLING_OPERATION_CODE));
			return result;
		},
		combinedPartiesSelected(): IPartialInvoice[] {
			return this.combinedSplitParties.filter((item) => item.IsSelected && item.ShareAmount > 0
			&& (item.SplitPartyTypeName === SPLIT_PARTIES.Individual || item.SplitPartyTypeName === SPLIT_PARTIES.Corporate || item.SplitPartyTypeName === SPLIT_PARTIES.Insurance));
		},
		disableCommonPay(): boolean {
			return this.combinedSplitParties.length === 1;
		},
	},
	mounted() {
		window.addEventListener('resize', () => {
			this.windowWidth = window.innerWidth;
		});
		this.nahled = this.props.filter.isProforma;
		this.isBillingScreen = this.props.filter.isBillingScreen;
	},
	watch: {
		PaymentPartTotal() {
			this.PartsTotalAmount = this.edit.PaymentPartTotal!;
		},
		PaymentLaborTotal() {
			this.LaborTotalAmount = this.edit.PaymentLaborTotal!;
		},
		PaymentTotalAmount() {
			this.PaymentTotalAmount = this.edit.PaymentTotalAmount!;
		},
		isPlatbaCiziMenou() {
			this.$nextTick(() => this.validator());
		},
		isPaymentMethodVisible() {
			this.isPaymentMethodApplicable = this.getSelectedNormalCustomers()?.length > 0;
		},
		DuzpDate() {
			if ((!this.DuzpDate && !this.OldDuzpDate) || this.isBezPlatby) return;

			const date = dayJs(this.OldDuzpDate || undefined);
			const duzpDate = dayJs(this.DuzpDate || undefined);

			if (this.HasPermissionDuzpDpp) {
				if (duzpDate.diff(date, 'day') > 15) {
					this.showErrorAlert({ message: 'DUZPDateCorect15' });
					this.DuzpDate = this.OldDuzpDate;
				}
			} else if (date.diff(duzpDate, 'day') !== 0) {
				this.showErrorAlert({ message: 'DUZPDateCorect15' });
				this.DuzpDate = this.OldDuzpDate;
			}
		},
		PlatbaPzn() {
			if (!this.platba || this.isBezPlatby) return;

			this.spocitejSplatnost();

			this.BankovniSpojeni1 = this.DefaultBankUcetId;
			if ((this as any).dmsSys.PokladnaPrp) {
				// TODO: why is LoggedUserMixin not recognized by TypeScript?
				(this as any).PokladnaIdVisible = this.platba.PokladnaPrp; // TODO: PokladnaIdVisible does not exist.
				this.filtrujPokladne();
			} else (this as any).PokladnaIdVisible = false; // TODO: PokladnaIdVisible does not exist.
		},
		FakturaceSubject() {
			if (!this.FakturaceSubject || this.isBezPlatby) return;
			this.SplatnostDoba = this.subjectSplatnostDoba!.SplatnostDoba;
			this.PlatbaPzn = this.subjectSplatnostDoba!.PlatbaPzn;
			this.spocitejSplatnost();
		},
		SplatnostDoba(val) {
			if (!this.SplatnostDate) {
				return;
			}

			this.SplatnostDate = dayJs(this.today).add(val, 'day').toDate();
		},
		isCommonPayment() {
			this.ResetPaymentDetails();
		},
		EguiTypes() {
			switch (this.EguiTypes) {
				case EGUI_TYPES.COMPANY: {
					this.iseGUITypeCompany = true;
					this.iseGUITypeWithCarrier = false;
					this.iseGUITypeNoCarrier = false;
					this.rdbEcpayCarrier = '0';
					this.rdbCarrier = '';
					this.CustomerName = '';
					this.invoiceRemark = this.EGUIDefaultRemarks;
					this.loveCode = '';
					this.barCode = '';
					this.digitalCertificate = '';
					this.CustomerIdentifier = this.defaultCustomerIdentifier != null && this.defaultCustomerIdentifier != '' ? this.defaultCustomerIdentifier : null;
					this.EguiTransDisplayOptions = 0;
					this.CashAmount = 0;
					this.CreditAmount = 0;
					this.DebitAmount = 0;
					this.OnlineAmount = 0;
					this.AdvanceTotalPayment = 0;
					break;
				}
				case EGUI_TYPES.WITH_CARRIER: {
					this.iseGUITypeCompany = false;
					this.iseGUITypeWithCarrier = true;
					this.iseGUITypeNoCarrier = false;
					this.rdbEcpayCarrier = '0';
					this.rdbCarrier = '';
					this.CustomerName = '';
					this.invoiceRemark = this.EGUIDefaultRemarks;
					this.loveCode = '';
					this.barCode = '';
					this.digitalCertificate = '';
					this.CustomerIdentifier = this.defaultCustomerIdentifier != null && this.defaultCustomerIdentifier != '' ? this.defaultCustomerIdentifier : null;
					this.EguiTransDisplayOptions = 0;
					this.CashAmount = 0;
					this.CreditAmount = 0;
					this.DebitAmount = 0;
					this.OnlineAmount = 0;
					this.AdvanceTotalPayment = 0;
					break;
				}
				case EGUI_TYPES.NO_CARRIER: {
					this.iseGUITypeCompany = false;
					this.iseGUITypeWithCarrier = false;
					this.iseGUITypeNoCarrier = true;
					this.rdbEcpayCarrier = '1';
					this.rdbCarrier = '';
					this.CustomerName = '';
					this.invoiceRemark = this.EGUIDefaultRemarks;
					this.loveCode = '';
					this.barCode = '';
					this.digitalCertificate = '';
					this.CustomerIdentifier = this.defaultCustomerIdentifier != null && this.defaultCustomerIdentifier != '' ? this.defaultCustomerIdentifier : null;
					this.EguiTransDisplayOptions = 0;
					this.CashAmount = 0;
					this.CreditAmount = 0;
					this.DebitAmount = 0;
					this.OnlineAmount = 0;
					this.AdvanceTotalPayment = 0;
					break;
				}
				default: {
					this.iseGUITypeCompany = false;
					this.iseGUITypeWithCarrier = false;
					this.iseGUITypeNoCarrier = false;
					this.rdbEcpayCarrier = '';
					this.rdbCarrier = '';
					this.CustomerName = '';
					this.invoiceRemark = this.EGUIDefaultRemarks;
					this.loveCode = '';
					this.barCode = '';
					this.digitalCertificate = '';
					this.CustomerIdentifier = this.defaultCustomerIdentifier != null && this.defaultCustomerIdentifier != '' ? this.defaultCustomerIdentifier : null;
					this.EguiTransDisplayOptions = 0;
					this.CashAmount = 0;
					this.CreditAmount = 0;
					this.DebitAmount = 0;
					this.OnlineAmount = 0;
					this.AdvanceTotalPayment = 0;
					break;
				}
			}
			this.isCINSplitSelected = false;
			this.isBarCodeSplitSelected = false;
			this.isCertificateSplitSelected = false;
			this.isLoveCodeSplitSelected = false;
		},
		EguiTypesSecond() {
			switch (this.EguiTypesSecond) {
				case EGUI_TYPES.COMPANY: {
					this.iseGUITypeCompanySecond = true;
					this.iseGUITypeWithCarrierSecond = false;
					this.iseGUITypeNoCarrierSecond = false;
					this.rdbEcpayCarrierSecond = '0';
					this.rdbCarrierSecond = '';
					this.CustomerNameSecond = '';
					this.invoiceRemarkSecond = this.EGUIDefaultRemarks;
					this.loveCodeSecond = '';
					this.barCodeSecond = '';
					this.digitalCertificateSecond = '';
					this.CustomerIdentifierSecond = this.defaultCustomerIdentifier != null && this.defaultCustomerIdentifier != '' ? this.defaultCustomerIdentifier : null;
					this.EguiTransDisplayOptionsSecond = 0;
					break;
				}
				case EGUI_TYPES.WITH_CARRIER: {
					this.iseGUITypeCompanySecond = false;
					this.iseGUITypeWithCarrierSecond = true;
					this.iseGUITypeNoCarrierSecond = false;
					this.rdbEcpayCarrierSecond = '0';
					this.rdbCarrierSecond = '';
					this.CustomerNameSecond = '';
					this.invoiceRemarkSecond = this.EGUIDefaultRemarks;
					this.loveCodeSecond = '';
					this.barCodeSecond = '';
					this.digitalCertificateSecond = '';
					this.CustomerIdentifierSecond = this.defaultCustomerIdentifier != null && this.defaultCustomerIdentifier != '' ? this.defaultCustomerIdentifier : null;
					this.EguiTransDisplayOptionsSecond = 0;
					break;
				}
				case EGUI_TYPES.NO_CARRIER: {
					this.iseGUITypeCompanySecond = false;
					this.iseGUITypeWithCarrierSecond = false;
					this.iseGUITypeNoCarrierSecond = true;
					this.rdbEcpayCarrierSecond = '1';
					this.rdbCarrierSecond = '';
					this.CustomerNameSecond = '';
					this.invoiceRemarkSecond = this.EGUIDefaultRemarks;
					this.loveCodeSecond = '';
					this.barCodeSecond = '';
					this.digitalCertificateSecond = '';
					this.CustomerIdentifierSecond = this.defaultCustomerIdentifier != null && this.defaultCustomerIdentifier != '' ? this.defaultCustomerIdentifier : null;
					this.EguiTransDisplayOptionsSecond = 0;
					break;
				}
				default: {
					this.iseGUITypeCompanySecond = false;
					this.iseGUITypeWithCarrierSecond = false;
					this.iseGUITypeNoCarrierSecond = false;
					this.rdbEcpayCarrierSecond = '';
					this.rdbCarrierSecond = '';
					this.CustomerNameSecond = '';
					this.invoiceRemarkSecond = '';
					this.loveCodeSecond = '';
					this.barCodeSecond = '';
					this.digitalCertificateSecond = '';
					this.CustomerIdentifierSecond = this.defaultCustomerIdentifier != null && this.defaultCustomerIdentifier != '' ? this.defaultCustomerIdentifier : null;
					this.EguiTransDisplayOptionsSecond = 0;
					break;
				}
			}
			this.isCINSplitSelectedSecond = false;
			this.isBarCodeSplitSelectedSecond = false;
			this.isCertificateSplitSelectedSecond = false;
			this.isLoveCodeSplitSelectedSecond = false;
		},
		CashAmount() {
			if (Number.isNaN(parseFloat(_.defaultTo(this.CashAmount, 0).toString()))) {
				this.AdvanceTotalPayment = parseFloat(_.defaultTo(this.CreditAmount, 0).toString()) + parseFloat(_.defaultTo(this.DebitAmount, 0).toString())
				+ parseFloat(_.defaultTo(this.OnlineAmount, 0).toString());
			} else {
				this.AdvanceTotalPayment = parseFloat(_.defaultTo(this.CashAmount, 0).toString()) + parseFloat(_.defaultTo(this.CreditAmount, 0).toString())
				+ parseFloat(_.defaultTo(this.DebitAmount, 0).toString()) + parseFloat(_.defaultTo(this.OnlineAmount, 0).toString());
			}
		},
		CreditAmount() {
			if (Number.isNaN(parseFloat(_.defaultTo(this.CreditAmount, 0).toString()))) {
				this.AdvanceTotalPayment = parseFloat(_.defaultTo(this.CashAmount, 0).toString()) + parseFloat(_.defaultTo(this.DebitAmount, 0).toString())
				+ parseFloat(_.defaultTo(this.OnlineAmount, 0).toString());
			} else {
				this.AdvanceTotalPayment = parseFloat(_.defaultTo(this.CashAmount, 0).toString()) + parseFloat(_.defaultTo(this.CreditAmount, 0).toString())
				+ parseFloat(_.defaultTo(this.DebitAmount, 0).toString()) + parseFloat(_.defaultTo(this.OnlineAmount, 0).toString());
			}
		},
		DebitAmount() {
			if (Number.isNaN(parseFloat(_.defaultTo(this.DebitAmount, 0).toString()))) {
				this.AdvanceTotalPayment = parseFloat(_.defaultTo(this.CashAmount, 0).toString()) + parseFloat(_.defaultTo(this.CreditAmount, 0).toString())
				+ parseFloat(_.defaultTo(this.OnlineAmount, 0).toString());
			} else {
				this.AdvanceTotalPayment = parseFloat(_.defaultTo(this.CashAmount, 0).toString()) + parseFloat(_.defaultTo(this.CreditAmount, 0).toString())
				+ parseFloat(_.defaultTo(this.DebitAmount, 0).toString()) + parseFloat(_.defaultTo(this.OnlineAmount, 0).toString());
			}
		},
		OnlineAmount() {
			if (Number.isNaN(parseFloat(_.defaultTo(this.OnlineAmount, 0).toString()))) {
				this.AdvanceTotalPayment = parseFloat(_.defaultTo(this.CashAmount, 0).toString()) + parseFloat(_.defaultTo(this.CreditAmount, 0).toString())
				+ parseFloat(_.defaultTo(this.DebitAmount, 0).toString());
			} else {
				this.AdvanceTotalPayment = parseFloat(_.defaultTo(this.CashAmount, 0).toString()) + parseFloat(_.defaultTo(this.CreditAmount, 0).toString())
				+ parseFloat(_.defaultTo(this.DebitAmount, 0).toString()) + parseFloat(_.defaultTo(this.OnlineAmount, 0).toString());
			}
		},
	},
	methods: {
		isEGUIEnabled(): boolean {
			return this.IsGUIEnabled;
		},
		eGUICloseCheckBeforePopUpClose(done: () => void) {
			if (!this.isEGUIEnabled()) {
				done();
			}
		},
		ResetPaymentDetails() {
			if (this.isCommonPayment) {
				this.combinedPartiesSelected.forEach(
					(m:any) => {
						m.AdvanceTotalPayment = 0;
						m.CashAmount = 0;
						m.CreditAmount = 0;
						m.DebitAmount = 0;
						m.OnlineAmount = 0;
					},
				);
			}
		},
		onSeperateCombineOptionChange(e:any) {
			if (e === EGUI_TRANS_OPTIONS.COMBINE) {
				this.seperateLabourItem = this.combineItem;
			} else {
				this.seperateLabourItem = this.seperateItem;
			}
		},
		onSeperateCombineOptionChangeSecond(e:any) {
			if (e === EGUI_TRANS_OPTIONS.COMBINE) {
				this.seperateLabourItemSecond = this.combineItem;
			} else {
				this.seperateLabourItemSecond = this.seperateItem;
			}
		},
		onEguiAdvPayChange(item: any, checked: boolean) {
			if (checked) {
				const otherItem = this.arrayeGUISplitDetails.filter(x => x.eGUISplitPartyTypeId != item.eGUISplitPartyTypeId)[0];
				if (this.arrayeGUISplitDetails.indexOf(otherItem) > -1 && otherItem.IsAdvancePayment == false) {
					this.arrayeGUISplitDetails[this.arrayeGUISplitDetails.indexOf(item)].IsAdvancePayment = true;
					return true;
				} else {
					this.arrayeGUISplitDetails[this.arrayeGUISplitDetails.indexOf(item)].IsAdvancePayment = false;
					return false;
				}
			}
		},
		onEguiSplitClick(checked:boolean) {
			if (checked) {
				this.paytotal = 0;
				this.paytotalSecond = 0;
				this.isSplitEGUI=true;
			} else {
				this.paytotal = this.PaymentTotalAmount!;
				this.EguiTypesSecond = null;
				this.isCINSplitSelectedSecond = false;
				this.CustomerIdentifierSecond = null;
				this.isBarCodeSplitSelectedSecond = false;
				this.barCodeSecond = null;
				this.isCertificateSplitSelectedSecond = false;
				this.digitalCertificateSecond = null;
				this.isLoveCodeSplitSelectedSecond = false;
				this.loveCodeSecond = null;
				this.EguiTransDisplayOptionsSecond = null;
				this.invoiceRemarkSecond = '';
			}
		},
		onEguiOptionChange(selection: any, checked: boolean) {
			if (checked) {
				this.rdbCarrier = selection;
				switch (this.rdbCarrier) {
					case this.cinCarrier:
						this.isCINSplitSelected = true;
						this.isBarCodeSplitSelected = false;
						this.isCertificateSplitSelected = false;
						this.isLoveCodeSplitSelected = false;
						break;
					case this.barCodeCarrier:
						this.isBarCodeSplitSelected = true;
						this.isCINSplitSelected = false;
						this.isCertificateSplitSelected = false;
						this.isLoveCodeSplitSelected = false;
						break;
					case this.certificateCarrier:
						this.isCertificateSplitSelected = true;
						this.isCINSplitSelected = false;
						this.isBarCodeSplitSelected = false;
						this.isLoveCodeSplitSelected = false;
						break;
					case this.donateCarrier:
						this.isLoveCodeSplitSelected = true;
						this.isCINSplitSelected = false;
						this.isBarCodeSplitSelected = false;
						this.isCertificateSplitSelected = false;
						break;
				}
			} else {
				this.rdbCarrier = '';
				this.isCINSplitSelected = false;
				this.isBarCodeSplitSelected = false;
				this.isCertificateSplitSelected = false;
				this.isLoveCodeSplitSelected = false;
			}
			this.loveCode = '';
			this.barCode = '';
			this.digitalCertificate = '';
			this.CustomerName = null;
			this.CustomerIdentifier = this.defaultCustomerIdentifier != null && this.defaultCustomerIdentifier != '' ? this.defaultCustomerIdentifier : null;
			this.invoiceRemark = this.EGUIDefaultRemarks;
		},
		onEguiOptionChangeSecond(selection: any, checked: boolean) {
			if (checked) {
				this.rdbCarrierSecond = selection;
				switch (this.rdbCarrierSecond) {
					case this.cinCarrierSecond:
						this.isCINSplitSelectedSecond = true;
						this.isBarCodeSplitSelectedSecond = false;
						this.isCertificateSplitSelectedSecond = false;
						this.isLoveCodeSplitSelectedSecond = false;
						break;
					case this.barCodeCarrierSecond:
						this.isBarCodeSplitSelectedSecond = true;
						this.isCINSplitSelectedSecond = false;
						this.isCertificateSplitSelectedSecond = false;
						this.isLoveCodeSplitSelectedSecond = false;
						break;
					case this.certificateCarrierSecond:
						this.isCertificateSplitSelectedSecond = true;
						this.isCINSplitSelectedSecond = false;
						this.isBarCodeSplitSelectedSecond = false;
						this.isLoveCodeSplitSelectedSecond = false;
						break;
					case this.donateCarrierSecond:
						this.isLoveCodeSplitSelectedSecond = true;
						this.isCINSplitSelectedSecond = false;
						this.isBarCodeSplitSelectedSecond = false;
						this.isCertificateSplitSelectedSecond = false;
						break;
				}
			} else {
				this.rdbCarrierSecond = '';
				this.isCINSplitSelectedSecond = false;
				this.isBarCodeSplitSelectedSecond = false;
				this.isCertificateSplitSelectedSecond = false;
				this.isLoveCodeSplitSelectedSecond = false;
			}
			this.loveCodeSecond = '';
			this.barCodeSecond = '';
			this.digitalCertificateSecond = '';
			this.CustomerNameSecond = null;
			this.CustomerIdentifierSecond = this.defaultCustomerIdentifier != null && this.defaultCustomerIdentifier != '' ? this.defaultCustomerIdentifier : null;
			this.invoiceRemarkSecond = this.EGUIDefaultRemarks;
		},
		async checkSagaStatus(): Promise<boolean> {
			try {
				this.sagaStatusMessage = '';
				const { data } = await Fakturace.apiProvider.pripravFakturaci(this.props.filter.dokladNaplnFakturaci!, this.props.filter.zakazkaDTO);
				const status = data?.Item1;
				const statusMessage = data?.Item2; 
				
				if (!status && !_.isUndefined(status)) {
					this.isSagaProcessed = true;					
					return true;
				} else {
					this.isSagaProcessed = false;
					this.sagaStatusMessage = statusMessage;
                    return false;
                }
			} catch {
				this.isSagaProcessed = false;
				return false;
			}
		},
		onCancelEGUI() {
			if (this.isEguiCancelPopupVisible) this.cancelEGUItxt = false;
		},
		cancelEGUIPopup() {
			if (this.isEguiCancelPopupVisible) {
				setTimeout(() => {
					this.recomputeHash();
					this.refreshPreviousPage = true;
					this.$router.go(-1);
				}, 5000);
			} else {
				setTimeout(() => {
					this.recomputeHash();
					this.refreshPreviousPage = true;
					this.$router.go(-2);
				}, 5000);
			}
			this.iseGUIVisible = false;
			this.isEguiCancelPopupVisible = false;
		},
		isEguiVisibleforOrders(items: any) : boolean {
			let isValid = false;
			this.ActualTotalPayment = 0;
			if (Array.isArray(items) && items.length > 0) {
				items.forEach((m:any) => {
					if ((m.SplitPartyTypeName === SPLIT_PARTIES.Individual || m.SplitPartyTypeName === SPLIT_PARTIES.Corporate || m.SplitPartyTypeName === SPLIT_PARTIES.Insurance)
						&& m.IsSelected && (this.edit.PaymentTotalAmount! > 0)) {
						this.ActualTotalPayment += m.ShareAmountWithVat;
						m.ActualTotalPayment = m.ShareAmountWithVat;
					}
				});
			}
			if (Array.isArray(items) && items.length > 0) {
				items.forEach((m:any) => {
					if ((m.SplitPartyTypeName === SPLIT_PARTIES.Individual || m.SplitPartyTypeName === SPLIT_PARTIES.Corporate || m.SplitPartyTypeName === SPLIT_PARTIES.Insurance)
						&& m.IsSelected && (this.edit.PaymentTotalAmount! > 0)) {
						if ((this.AdvanceAmount !== null && this.AdvanceAmount > 0)
							&& this.ZakaznikId === m.CustomerId && (m.ShareAmount === this.AdvanceAmount || m.ShareAmount <= this.AdvanceAmount
							|| m.ShareAmountWithVat <= this.AdvanceAmount || this.edit.PaymentTotalAmount! === this.AdvanceAmount)) {
							isValid = false;
							return isValid;
						}
					}
					if ((m.SplitPartyTypeName === SPLIT_PARTIES.Individual || m.SplitPartyTypeName === SPLIT_PARTIES.Corporate || m.SplitPartyTypeName === SPLIT_PARTIES.Insurance)
						&& m.IsSelected && (this.isReverseJobOrderVisible || this.edit.PaymentTotalAmount! > 0)) {
						isValid = true;
						return isValid;
					}
				});
			}
			return isValid;
		},
		async oneGUISplitOptionSelected() {
			if (this.PaymentTotalAmount === 1 && this.isSplitEligible) {
				this.showErrorAlert({
					title: this.LocalizeChyboveHlasky('DMS3_ErrorTitle'),
					message: `${this.LocalizeChyboveHlasky('eGUIValidateOneAmount')}`,
					options: { type: 'error' },
				});
				return false;
			}
			if (this.isSplitEligible) {
				const returnValue = await this.eGUIFirstValidations();
				if (!returnValue) {
					return false;
				}
				const returnValueSecondEGUI = await this.eGUISecondValidations();
				if (returnValue && returnValueSecondEGUI) {
					this.isShoweGUISummary = true;
					this.getFirstEGUISplitAmounts();
					this.getSecondEGUISplitAmounts();
				}
			} else if (await this.eGUIFirstValidations()) {
				this.isShoweGUISummary = true;
				this.getFirstEGUISplitAmounts();
			}
		},
		async eGUIFirstValidations() : Promise<boolean> {
			let returnValue = false;
			if (this.rdbEcpayCarrier === '' || (this.rdbEcpayCarrier == this.ownCarrier && this.rdbCarrier === '')) {
				this.showErrorAlert({
					title: this.LocalizeChyboveHlasky('DMS3_ErrorTitle'),
					message: `${this.LocalizeChyboveHlasky('eGUIOptionSelect')} ${':'} ${this.LocalizePopisostatni('FIRST_INVOICE')}`,
					options: { type: 'error' },
				});
				returnValue = false;
			} else if (this.rdbEcpayCarrier == this.eCpayCarrier) {
				returnValue = true;
			} else if (this.lbleGUI === EGUI_OPTIONS.EGUI_ISSUE) {
				if (this.barCode !== '' && this.isBarCodeValid(this.barCode!)) {
					returnValue = true;
				} else if (this.digitalCertificate !== '' && this.isDigitalCertificateValid(this.digitalCertificate!)) {
					returnValue = true;
				} else if (this.loveCode !== '' && this.isLoveCodeValid(this.loveCode!)) {
					returnValue = true;
				} else if (this.rdbCarrier == this.cinCarrier) {
					if (this.rdbCarrier == this.cinCarrier && (this.CustomerIdentifier == null || this.CustomerIdentifier === '')) {
						this.showErrorAlert({
							title: this.LocalizeChyboveHlasky('DMS3_ErrorTitle'),
							message: `${this.LocalizeChyboveHlasky('Egui_CIN_Required_Error')} ${':'} ${this.LocalizePopisostatni('FIRST_INVOICE')}`,
							options: { type: 'error' },
						});
						returnValue = false;
					} else returnValue = true;
				} else {
					if ((this.rdbCarrier == this.barCodeCarrier && this.barCode === '') || (this.barCode !== '' && !this.isBarCodeValid(this.barCode!))) {
						this.showErrorAlert({
							title: this.LocalizeChyboveHlasky('DMS3_ErrorTitle'),
							message: `${this.LocalizeChyboveHlasky('eGUIBarcodeInvalid')} ${':'} ${this.LocalizePopisostatni('FIRST_INVOICE')}`,
							options: { type: 'error' },
						});
						returnValue = false;
					} else if ((this.rdbCarrier == this.certificateCarrier && this.digitalCertificate === '') || (this.digitalCertificate !== '' && !this.isDigitalCertificateValid(this.digitalCertificate!))) {
						this.showErrorAlert({
							title: this.LocalizeChyboveHlasky('DMS3_ErrorTitle'),
							message: `${this.LocalizeChyboveHlasky('eGUIDigiCertInvalid')} ${':'} ${this.LocalizePopisostatni('FIRST_INVOICE')}`,
							options: { type: 'error' },
						});
						returnValue = false;
					} else if ((this.rdbCarrier == this.donateCarrier && this.loveCode === '') || (this.loveCode !== '' && !this.isLoveCodeValid(this.loveCode!))) {
						this.showErrorAlert({
							title: this.LocalizeChyboveHlasky('DMS3_ErrorTitle'),
							message: `${this.LocalizeChyboveHlasky('eGUILoveCodeInvalid')} ${':'} ${this.LocalizePopisostatni('FIRST_INVOICE')}`,
							options: { type: 'error' },
						});
						returnValue = false;
					} else {
						this.showErrorAlert({
							title: this.LocalizeChyboveHlasky('DMS3_ErrorTitle'),
							message: `${this.LocalizeChyboveHlasky('eGUIIssueInvalidInp')} ${':'} ${this.LocalizePopisostatni('FIRST_INVOICE')}`,
							options: { type: 'error' },
						});
						returnValue = false;
					}
				}
			} else {
				returnValue = true;
			}
			let errormsg = '';
			if (returnValue && !Number.isNaN(parseFloat(_.defaultTo(this.paytotal, 0).toString()))) {
				if (this.isSplitEligible) {
					if ((this.paytotal + this.paytotalSecond) !== this.PaymentTotalAmount!) {
						errormsg = `${this.LocalizeChyboveHlasky('eGUIFirstSplitTotalValidate').replace('@EGUIAMOUNT', (this.paytotal + this.paytotalSecond).toString())
							.replace('@INVAMOUNT', this.PaymentTotalAmount!.toString())} ${':'} ${this.LocalizePopisostatni('FIRST_INVOICE')}`;
						returnValue = false;
					} else if (this.paytotal <= 0) {
						errormsg = `${this.LocalizeChyboveHlasky('eGUISplitTotalValidate')} ${':'} ${this.LocalizePopisostatni('FIRST_INVOICE')}`;
					 	returnValue = false;
					}
				} else {
					if (this.paytotal !== this.PaymentTotalAmount!) {
						errormsg = `${this.LocalizeChyboveHlasky('eGUIFirstSplitTotalValidate').replace('@EGUIAMOUNT', this.paytotal.toString())
							.replace('@INVAMOUNT', this.PaymentTotalAmount!.toString())} ${':'} ${this.LocalizePopisostatni('FIRST_INVOICE')}`;
						returnValue = false;
					}
				}
			}
			if (returnValue && (this.EguiTransDisplayOptions == null || this.EguiTransDisplayOptions == 0)) {
				errormsg = `${this.LocalizeChyboveHlasky('eGUITransDetailsInvalid')} ${':'} ${this.LocalizePopisostatni('FIRST_INVOICE')}`;
				returnValue = false;
			}
			if (errormsg != null && errormsg !== '') {
				showAlert({
					message: errormsg,
					title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
					options: { type: 'info' },
				});
				returnValue = false;
			}
			return returnValue;
		},
		async eGUISecondValidations() : Promise<boolean> {
			let returnValue = false;
			if (this.rdbEcpayCarrierSecond === '' || (this.rdbEcpayCarrierSecond == this.ownCarrier && this.rdbCarrierSecond === '')) {
				this.showErrorAlert({
					title: this.LocalizeChyboveHlasky('DMS3_ErrorTitle'),
					message: `${this.LocalizeChyboveHlasky('eGUIOptionSelect')} ${':'} ${this.LocalizePopisostatni('SECOND_INVOICE')}`,
					options: { type: 'error' },
				});
				returnValue = false;
			} else if (this.rdbEcpayCarrierSecond == this.eCpayCarrier) {
				returnValue = true;
			} else if (this.lbleGUI === EGUI_OPTIONS.EGUI_ISSUE) {
				if (this.barCodeSecond !== '' && this.isBarCodeValid(this.barCodeSecond!)) {
					returnValue = true;
				} else if (this.digitalCertificateSecond !== '' && this.isDigitalCertificateValid(this.digitalCertificateSecond!)) {
					returnValue = true;
				} else if (this.loveCodeSecond !== '' && this.isLoveCodeValid(this.loveCodeSecond!)) {
					returnValue = true;
				} else if (this.rdbCarrierSecond == this.cinCarrierSecond) {
					if (this.rdbCarrierSecond == this.cinCarrierSecond && (this.CustomerIdentifierSecond == null || this.CustomerIdentifierSecond === '')) {
						this.showErrorAlert({
							title: this.LocalizeChyboveHlasky('DMS3_ErrorTitle'),
							message: `${this.LocalizeChyboveHlasky('Egui_CIN_Required_Error')} ${':'} ${this.LocalizePopisostatni('SECOND_INVOICE')}`,
							options: { type: 'error' },
						});
						returnValue = false;
					} else returnValue = true;
				} else {
					if ((this.rdbCarrierSecond == this.barCodeCarrierSecond && this.barCodeSecond === '') || (this.barCodeSecond !== '' && !this.isBarCodeValid(this.barCodeSecond!))) {
						this.showErrorAlert({
							title: this.LocalizeChyboveHlasky('DMS3_ErrorTitle'),
							message: `${this.LocalizeChyboveHlasky('eGUIBarcodeInvalid')} ${':'} ${this.LocalizePopisostatni('SECOND_INVOICE')}`,
							options: { type: 'error' },
						});
						returnValue = false;
					} else if ((this.rdbCarrierSecond == this.certificateCarrierSecond && this.digitalCertificateSecond === '') || (this.digitalCertificateSecond !== '' && !this.isDigitalCertificateValid(this.digitalCertificateSecond!))) {
						this.showErrorAlert({
							title: this.LocalizeChyboveHlasky('DMS3_ErrorTitle'),
							message: `${this.LocalizeChyboveHlasky('eGUIDigiCertInvalid')} ${':'} ${this.LocalizePopisostatni('SECOND_INVOICE')}`,
							options: { type: 'error' },
						});
						returnValue = false;
					} else if ((this.rdbCarrierSecond == this.donateCarrierSecond && this.loveCodeSecond === '') || (this.loveCodeSecond !== '' && !this.isLoveCodeValid(this.loveCodeSecond!))) {
						this.showErrorAlert({
							title: this.LocalizeChyboveHlasky('DMS3_ErrorTitle'),
							message: `${this.LocalizeChyboveHlasky('eGUILoveCodeInvalid')} ${':'} ${this.LocalizePopisostatni('SECOND_INVOICE')}`,
							options: { type: 'error' },
						});
						returnValue = false;
					} else {
						this.showErrorAlert({
							title: this.LocalizeChyboveHlasky('DMS3_ErrorTitle'),
							message: `${this.LocalizeChyboveHlasky('eGUIIssueInvalidInp')} ${':'} ${this.LocalizePopisostatni('SECOND_INVOICE')}`,
							options: { type: 'error' },
						});
						returnValue = false;
					}
				}
			} else {
				returnValue = true;
			}
			let errormsg = '';
			if (returnValue && !Number.isNaN(parseFloat(_.defaultTo(this.paytotalSecond, 0).toString()))) {
				if (this.isSplitEligible) {
					if (this.paytotalSecond <= 0) {
						errormsg = `${this.LocalizeChyboveHlasky('eGUISplitTotalValidateSecond')} ${':'} ${this.LocalizePopisostatni('SECOND_INVOICE')}`;
						returnValue = false;
					} else if ((this.paytotalSecond + this.paytotal) !== this.PaymentTotalAmount!) {
						errormsg = `${this.LocalizeChyboveHlasky('eGUIFirstSplitTotalValidate').replace('@EGUIAMOUNT', (this.paytotal + this.paytotalSecond).toString())
							.replace('@INVAMOUNT', this.PaymentTotalAmount!.toString())} ${':'} ${this.LocalizePopisostatni('SECOND_INVOICE')}`;
						returnValue = false;
					}
				}
			}
			if (returnValue && (this.EguiTransDisplayOptionsSecond == null || this.EguiTransDisplayOptionsSecond == 0)) {
				errormsg = `${this.LocalizeChyboveHlasky('eGUITransDetailsInvalid')} ${':'} ${this.LocalizePopisostatni('SECOND_INVOICE')}`;
				returnValue = false;
			}
			if (errormsg != null && errormsg !== '') {
				showAlert({
					message: errormsg,
					title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
					options: { type: 'info' },
				});
				returnValue = false;
			}
			return returnValue;
		},
		async eGUIIssueSPlittedInvoice() {
			if (this.isEGUIOptionAvailable) {
				this.iseGUIIssuePopUpVisible = false;
				this.iseGUIVisible = false;
				switch (this.seperateLabourItem) {
					case this.seperateItem:
						this.IsItemSeparated = EGUI_OPTIONS.IS_ITEM_SEPRATED;
						break;
					case this.combineItem:
						this.IsItemSeparated = EGUI_OPTIONS.IS_ITEM_NOT_SEPRATED;
						break;
				}
				let CurrentCustomerIdentifier;
				let CurrentCustomerName;
				let CurrentDonation;
				let CurrentCarrierType;
				let CurrentCarrierNum;
				let CurrentLoveCode;
				let PartyTypeId = this.isCINSplitSelected ? this.cinCarrier : (this.isBarCodeSplitSelected ? this.barCodeCarrier :
							(this.isCertificateSplitSelected ? this.certificateCarrier : (this.isLoveCodeSplitSelected ? this.donateCarrier : this.eGUISplitPartyTypeIdForNoCarrier)));
				if (this.isCINSplitSelected && PartyTypeId == this.cinCarrier) {
					CurrentCustomerIdentifier = (this.edit.CustomerIdentifier != null && this.edit.CustomerIdentifier != '') ? this.edit.CustomerIdentifier : '';
					CurrentCustomerName = (this.edit.CustomerName != null && this.edit.CustomerName != '') ? this.edit.CustomerName : '';
					CurrentDonation = this.ownCarrier;
					CurrentCarrierType = this.cinCarrier;
					CurrentCarrierNum = '';
					CurrentLoveCode = null;
				} else if (this.isBarCodeSplitSelected && PartyTypeId == this.barCodeCarrier) {
					CurrentCarrierType = this.barCodeCarrier;
					CurrentCarrierNum = (this.barCode != null && this.barCode != '') ? this.barCode : '';
					CurrentDonation = this.ownCarrier;
					CurrentCustomerIdentifier = null;
					CurrentCustomerName = null;
					CurrentLoveCode = null;
				} else if (this.isCertificateSplitSelected && PartyTypeId == this.certificateCarrier) {
					CurrentCarrierType = this.certificateCarrier;
					CurrentCarrierNum = (this.digitalCertificate != null && this.digitalCertificate != '') ? this.digitalCertificate : '';
					CurrentDonation = this.ownCarrier;
					CurrentCustomerIdentifier = null;
					CurrentCustomerName = null;
					CurrentLoveCode = null;
				} else if (this.isLoveCodeSplitSelected && PartyTypeId == this.donateCarrier) {
					CurrentDonation = this.eCpayCarrier;
					CurrentCustomerIdentifier = null;
					CurrentCustomerName = null;
					CurrentCarrierType = this.donateCarrier;
					CurrentCarrierNum = '';
					CurrentLoveCode = (this.loveCode != null && this.loveCode != '') ? this.loveCode : '';
				} else {
					CurrentDonation = this.ownCarrier;
					CurrentCustomerIdentifier = null;
					CurrentCustomerName = null;
					CurrentCarrierType = this.rdbEcpayCarrier;
					CurrentCarrierNum = '';
					CurrentLoveCode = '';
				}
				let PartyName = '';
				switch (PartyTypeId) {
					case this.cinCarrier:
						PartyName = this.LocalizePopisPoli('CUSTOMER_IDENTIFIER');
						break;
					case this.barCodeCarrier:
						PartyName = this.LocalizePopisPoli('BARCODECARRIER');
						break;
					case this.certificateCarrier:
						PartyName = this.LocalizePopisPoli('CERTIFICATECARRIER');
						break;
					case this.donateCarrier:
						PartyName = this.LocalizePopisPoli('DONATECARRIER');
						break;
					case this.eGUISplitPartyTypeIdForNoCarrier:
						PartyName = this.LocalizePopisPoli('NO_CARRIER');
						break;
				}
				let currentSplitElement = {
					eGUISplitPartyTypeName: PartyName,
					eGUISplitPartyTypeId: this.combinedPartiesSelected[0].SplitPartyTypeId,
					SharePercentage: 0,
					OldSharePercentage: 0,
					ShareAmount: this.TotalFirstEGUIPartsAmount + this.TotalFirstEGUILaborAmount,
					OldShareAmount: 0,
					PartsAmount: this.TotalFirstEGUIPartsAmount,
					LaborAmount: this.TotalFirstEGUILaborAmount,
					CashAmount: 0,
					CreditAmount: 0,
					DebitAmount: 0,
					OnlineAmount: 0,
					AdvanceTotalPayment: 0,
					ActualTotalPayment: this.paytotal,
					ActualShareTotalPayment: 0,
					Donation: CurrentDonation,
					LoveCode: CurrentLoveCode,
					CarrierType: CurrentCarrierType,
					CarrierNum: CurrentCarrierNum,
					CustomerName: CurrentCustomerName,
					CustomerIdentifier: CurrentCustomerIdentifier,
					IsAdvancePayment: false,
					IsItemSeparated: this.IsItemSeparated,
					InvoiceRemark: this.invoiceRemark,
					DPHandlingFee: this.DPHandlingFee,
					DPDealerDeduction: this.DPDealerDeduction,
					DPOEMDeduction: this.DPOEMDeduction,
					DPRoundOff: this.DPRoundOff,
				};
				this.arrayeGUISplitDetails = [];
				this.arrayeGUISplitDetails.push(currentSplitElement);
				if (this.isSplitEligible) {
					switch (this.seperateLabourItemSecond) {
						case this.seperateItem:
							this.IsItemSeparated = EGUI_OPTIONS.IS_ITEM_SEPRATED;
							break;
						case this.combineItem:
							this.IsItemSeparated = EGUI_OPTIONS.IS_ITEM_NOT_SEPRATED;
							break;
					}
					PartyTypeId = this.isCINSplitSelectedSecond ? this.cinCarrier : (this.isBarCodeSplitSelectedSecond ? this.barCodeCarrier :
								(this.isCertificateSplitSelectedSecond ? this.certificateCarrier : (this.isLoveCodeSplitSelectedSecond ? this.donateCarrier : this.eGUISplitPartyTypeIdForNoCarrier)));
					if (this.isCINSplitSelectedSecond && (PartyTypeId == this.cinCarrier || PartyTypeId == this.cinCarrierSecond)) {
						CurrentCustomerIdentifier = (this.edit.CustomerIdentifierSecond != null && this.edit.CustomerIdentifierSecond != '') ? this.edit.CustomerIdentifierSecond : '';
						CurrentCustomerName = (this.edit.CustomerNameSecond != null && this.edit.CustomerNameSecond != '') ? this.edit.CustomerNameSecond : '';
						CurrentDonation = this.ownCarrier;
						CurrentCarrierType = this.cinCarrier;
						CurrentCarrierNum = '';
						CurrentLoveCode = null;
					} else if (this.isBarCodeSplitSelectedSecond && (PartyTypeId == this.barCodeCarrier || PartyTypeId == this.barCodeCarrierSecond)) {
						CurrentCarrierType = this.barCodeCarrier;
						CurrentCarrierNum = (this.barCodeSecond != null && this.barCodeSecond != '') ? this.barCodeSecond : '';
						CurrentDonation = this.ownCarrier;
						CurrentCustomerIdentifier = null;
						CurrentCustomerName = null;
						CurrentLoveCode = null;
					} else if (this.isCertificateSplitSelectedSecond && (PartyTypeId == this.certificateCarrier || PartyTypeId == this.certificateCarrierSecond)) {
						CurrentCarrierType = this.certificateCarrier;
						CurrentCarrierNum = (this.digitalCertificateSecond != null && this.digitalCertificateSecond != '') ? this.digitalCertificateSecond : '';
						CurrentDonation = this.ownCarrier;
						CurrentCustomerIdentifier = null;
						CurrentCustomerName = null;
						CurrentLoveCode = null;
					} else if (this.isLoveCodeSplitSelected && (PartyTypeId == this.donateCarrier || PartyTypeId == this.donateCarrierSecond)) {
						CurrentDonation = this.eCpayCarrier;
						CurrentCustomerIdentifier = null;
						CurrentCustomerName = null;
						CurrentCarrierType = this.donateCarrier;
						CurrentCarrierNum = '';
						CurrentLoveCode = (this.loveCodeSecond != null && this.loveCodeSecond != '') ? this.loveCodeSecond : '';
					} else {
						CurrentDonation = this.ownCarrier;
						CurrentCustomerIdentifier = null;
						CurrentCustomerName = null;
						CurrentCarrierType = this.rdbEcpayCarrier;
						CurrentCarrierNum = '';
						CurrentLoveCode = '';
					}
					PartyName = '';
					switch (PartyTypeId) {
						case this.cinCarrier:
							PartyName = this.LocalizePopisPoli('CUSTOMER_IDENTIFIER');
							break;
						case this.barCodeCarrier:
							PartyName = this.LocalizePopisPoli('BARCODECARRIER');
							break;
						case this.certificateCarrier:
							PartyName = this.LocalizePopisPoli('CERTIFICATECARRIER');
							break;
						case this.donateCarrier:
							PartyName = this.LocalizePopisPoli('DONATECARRIER');
							break;
						case this.eGUISplitPartyTypeIdForNoCarrier:
							PartyName = this.LocalizePopisPoli('NO_CARRIER');
							break;
					}
					currentSplitElement = {
						eGUISplitPartyTypeName: PartyName,
						eGUISplitPartyTypeId: this.combinedPartiesSelected[0].SplitPartyTypeId,
						SharePercentage: 0,
						OldSharePercentage: 0,
						ShareAmount: this.paytotalSecond,
						OldShareAmount: 0,
						PartsAmount: this.SecondEGUIPartsAmount,
						LaborAmount: this.SecondEGUILaborAmount,
						CashAmount: 0,
						CreditAmount: 0,
						DebitAmount: 0,
						OnlineAmount: 0,
						AdvanceTotalPayment: 0,
						ActualTotalPayment: this.paytotalSecond,
						ActualShareTotalPayment: 0,
						Donation: CurrentDonation,
						LoveCode: CurrentLoveCode,
						CarrierType: CurrentCarrierType,
						CarrierNum: CurrentCarrierNum,
						CustomerName: CurrentCustomerName,
						CustomerIdentifier: CurrentCustomerIdentifier,
						IsAdvancePayment: false,
						IsItemSeparated: this.IsItemSeparated,
						InvoiceRemark: this.invoiceRemarkSecond,
						DPHandlingFee: this.DPHandlingFee,
						DPDealerDeduction: this.DPDealerDeduction,
						DPOEMDeduction: this.DPOEMDeduction,
						DPRoundOff: this.DPRoundOff,
					};
					this.arrayeGUISplitDetails.push(currentSplitElement);
				}
				this.startLoading();
				this.edit.CustomerSplit = [];
				this.edit.OEMSplit = [];
				this.edit.ObjeGUISplitDetails = this.arrayeGUISplitDetails;
				const fakturaceDto = {
					ZakazkaId: this.ZakazkaId,
					ZakaznikId: this.combinedPartiesSelected[0].CustomerId,
					JinyPrijemceId: this.JinyPrijemceId,
					LeaszakaznikId: this.LeaszakaznikId,
					PojistovnaId: this.PojistovnaId,
					PartialInvoices: this.PartialInvoices,
					ObjeGUISplitDetails: this.arrayeGUISplitDetails,
					EguiPaymentMethod: this.EguiPaymentMethod,
					ISsplitEGUIgenerated:this.isSplitEGUI,
					IsGUIEnabled:this.IsGUIEnabled,
				};
				const response = await apiProvider.eGUISplitIssueInvoice(fakturaceDto);
				this.endLoading();
				if (response !== null && response.data !== '') {
					if (response.data.RtnCode === this.eguiSuccessCode) {	
						const SUCCESS_MSG = EGUI_OPTIONS.EGUI_SUCCESS;
						const isAnyEGUIFailed = !response.data.RtnMsg.includes(SUCCESS_MSG);
						const rtnMsg = response.data.RtnMsg;
						
						if (this.isBarCodeSplitSelected || this.isLoveCodeSplitSelected || this.isCertificateSplitSelected
							|| this.isBarCodeSplitSelectedSecond || this.isLoveCodeSplitSelectedSecond || this.isCertificateSplitSelectedSecond
						) {
							const carrierInvoices = response.data.CarrierEguiNumbers?.length > 0
								? `: ${response.data.CarrierEguiNumbers.join(', ')}`
								: '';

							if (this.isCINSplitSelected || this.isCINSplitSelectedSecond || this.iseGUITypeNoCarrier || this.iseGUITypeNoCarrierSecond) {
								setTimeout(() => {
									this.showErrorAlert({
										title: '',
										message: isAnyEGUIFailed?`${rtnMsg} ${this.LocalizeChyboveHlasky('eGUIIssueSuccess')} ${this.LocalizeChyboveHlasky('printingNotAllowed')}${carrierInvoices}`:`${this.LocalizeChyboveHlasky('eGUIIssueSuccess')} ${this.LocalizeChyboveHlasky('printingNotAllowed')}${carrierInvoices}`,
										options: { type: 'info' },
									});
								}, 5000);
							} else {
								this.showErrorAlert({
									title: '',
									message: isAnyEGUIFailed?`${rtnMsg} ${this.LocalizeChyboveHlasky('eGUIIssueSuccess')} ${this.LocalizeChyboveHlasky('printingNotAllowed')}${carrierInvoices}`:`${this.LocalizeChyboveHlasky('eGUIIssueSuccess')} ${this.LocalizeChyboveHlasky('printingNotAllowed')}${carrierInvoices}`,
									options: { type: 'info' },
								});
							}
                            
						}
						if (this.isCINSplitSelected || this.isCINSplitSelectedSecond || this.iseGUITypeNoCarrier || this.iseGUITypeNoCarrierSecond) {	
							const questionResult = await this.showConfirm({
								title: this.LocalizePopisostatni('CRMDotaz'),
								message: isAnyEGUIFailed?`${rtnMsg} ${this.LocalizeChyboveHlasky('eGUIIssueSuccess')} ${this.LocalizeChyboveHlasky('eGUIPrintReceipt')}`:`${this.LocalizeChyboveHlasky('eGUIIssueSuccess')} ${this.LocalizeChyboveHlasky('eGUIPrintReceipt')}`,
								options: {
									confirmButtonText: this.Localize('Ano'),
									cancelButtonText: this.Localize('Ne'),
								},
							});
							if (questionResult) {
								this.eGUIPrintInvoice(true);
							}
						}						
					} else if ((response.data.RtnMsg).includes(EGUI_OPTIONS.EGUI_ADVANCE_AMOUNT_MORE)) {
						showAlert({
							message: this.LocalizeChyboveHlasky('AdvanceAmountGreater'),
							title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
							options: { type: 'info' },
						});
					} else {
						this.showErrorAlert({
							title: this.LocalizeChyboveHlasky('DMS3_ErrorTitle'),
							message: `${this.LocalizeChyboveHlasky('eGUIIssueFail')} ${response.data.RtnMsg}`,
							options: { type: 'error' },
						});
					}
				} else if (response.data.RtnMsg !== '' && response.data.RtnMsg !== undefined) {
					this.showErrorAlert({
						title: '',
						message: `${this.LocalizeChyboveHlasky('eGUIIssueFail')} ${response.data.RtnMsg}`,
						options: { type: 'error' },
					});
				}
				setTimeout(() => {
					this.recomputeHash();
					this.refreshPreviousPage = true;
					this.$router.go(-2);
				}, 5000);
			}
		},
		async eGUICancelInvoice() {
			this.iseGUIIssuePopUpVisible = false;
			this.iseGUIVisible = false;
			this.startLoading();
			const eGUICancelInvoiceRequestDTO = {
				ZakazkaId: this.ZakazkaId,
				CancelInvoicedNo: this.CancelInvoicedNo,
				ZakaznikId: this.ZakaznikId,
			};
			const { data: response } = await apiProvider.eGUICancelInvoice(eGUICancelInvoiceRequestDTO);
			this.endLoading();
			if (response !== null && response !== '' && response.RtnCode === this.eguiSuccessCode && this.isEGUIOptionAvailable) {
				this.showErrorAlert({
					title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
					message: `${this.LocalizeChyboveHlasky('eGUICancelSuccess')}`,
					options: { type: 'info' },
				});
			} else if (this.isEGUIOptionAvailable) {
				this.showErrorAlert({
					title: this.LocalizeChyboveHlasky('DMS3_ErrorTitle'),
					message: this.LocalizeChyboveHlasky('eGUICancelFail'),
					options: { type: 'error' },
				});
			}
			setTimeout(() => {
				this.recomputeHash();
				this.refreshPreviousPage = true;
				this.$router.go(-1);
			}, 5000);
		},
		async eGUIPrintInvoice(isFromBilling: boolean) {
			this.iseGUIIssuePopUpVisible = false;
			this.iseGUIVisible = false;
			this.startLoading();
			const eGUIPrintInvoiceRequestDTO = {
				ZakazkaId: this.ZakazkaId,
				CustomerId: this.combinedPartiesSelected[0].CustomerId!.toString(),
				FromBilling: true,

			};
			const { data: response } = await apiProvider.eGUIPrintInvoice(eGUIPrintInvoiceRequestDTO);
			this.endLoading();
			if (response !== null && response !== '' && response.RtnCode === this.eguiSuccessCode) { // success
				const invoiceItems = response?.InvoiceHtmlForSplit.split(',');
				for (let iItem = 0; iItem < invoiceItems.length; iItem++) {
					window.open(invoiceItems[iItem], '_blank');
				}
				if (this.isSplitAllowed && response.RtnMsg == '查無資料' && !isFromBilling && response?.CarrierFailedEguiNumbers?.length > 0) {
					const eguiList = response.CarrierFailedEguiNumbers.join(', ');
					this.showErrorAlert({
						title: '',
						message: `${this.LocalizeChyboveHlasky('printingNotAllowed')}${eguiList}`,
						options: { type: 'info' },
					});
				}
			} else if (response.RtnCode === EGUI_OPTIONS.EGUI_RTN_CODE && !isFromBilling) {
				const eguiList = response?.CarrierFailedEguiNumbers?.length ? response.CarrierFailedEguiNumbers.join(', ') : '';
				this.showErrorAlert({
					title: '',
					message: `${this.LocalizeChyboveHlasky('printingNotAllowed')}${eguiList}`,
					options: { type: 'info' },
				});
			} else {
				this.showErrorAlert({
					title: this.LocalizeChyboveHlasky('DMS3_ErrorTitle'),
					message: this.LocalizeChyboveHlasky('eGUIPrintFail'),
					options: { type: 'error' },
				});
			}
		},
		loadedData() {
			this.combinedSplitParties = this.CustomerSplit.concat(this.OEMSplit);
			if (this.DealershipSplit) {
				this.combinedSplitParties.push(this.DealershipSplit);
			}
			if (this.combinedSplitParties?.length === 1) {
				this.combinedSplitParties[PRIMARY_CUSTOMER_SPLIT_INDEX].IsSelected = true;
				if (this.dmsSys.EGUISplitPrp && this.isNotProforma) {
					this.isSplitAllowed = true;
				}

				const selectedCustomers = this.getSelectedNormalCustomers();
				this.isPaymentMethodApplicable = this.isNotProforma && !this.isCreditNote && selectedCustomers?.length === 1;
				if (this.isPaymentMethodApplicable === true) {
					this.displayPaymentMethods(selectedCustomers[0], this.isPaymentMethodApplicable);
				}
			}
			this.unbilledSplitPartiesCount = this.combinedSplitParties.filter(x => !x.IsBilled)?.length ?? 0;
			if (this.CustomerIdentifier) this.defaultCustomerIdentifier = this.CustomerIdentifier;

			if (!this.isBillingScreen && !this.isCreditNote) {
				this.isSelectAllVisible = true;
			}
		},
		isBarCodeValid(barCode: string): boolean {
			const emailRegExp = new RegExp('^/[A-Z0-9.\\-+]{7}$');
			return emailRegExp.test(barCode);
		},
		isDigitalCertificateValid(certificateCode: string): boolean {
			const emailRegExp = new RegExp('^[A-Z]{2}[0-9]{14}$');
			return emailRegExp.test(certificateCode);
		},
		isLoveCodeValid(loveCode: string): boolean {
			const emailRegExp = new RegExp('^[0-9]{3,7}$');
			return emailRegExp.test(loveCode);
		},
		async onIssueClick() {
			if (this.lbleGUI === EGUI_OPTIONS.EGUI_ISSUE) {
				this.iseGUIIssuePopUpVisible = true;
				this.firstEguiCustomerName = this.getCustomerEguiSplit('FIRST_INVOICE');
				this.secondEguiCustomerName = this.getCustomerEguiSplit('SECOND_INVOICE');
			}
		},
		getSplitPartyValue(item: any): string {
			if (item.IsBilled && !item.IsCreditNote) {
				return `${item.CustomerName} (${this.getLocalizedLabel('InvoicedOn')} - ${this.formattedDate(item.BillingDate)})`;
			}
			if (item.IsCreditNote && !item.IsBilled) {
				return `${item.CustomerName} (${this.getLocalizedLabel('CreditNoteOn')} - ${this.formattedDate(item.CreditNoteDate)})`;
			}
			return item.CustomerName;
		},
		getSelectedNormalCustomers() {
            return this.combinedSplitParties.filter(item => item.IsSelected && !item.IsBilled &&
														(item.SplitPartyTypeName === SPLIT_PARTIES.Individual || 
														item.SplitPartyTypeName === SPLIT_PARTIES.Corporate || item.SplitPartyTypeName === SPLIT_PARTIES.Insurance));
        },
		async onCheckValueUpdate(partialInvoiceItem : IPartialInvoice, isChecked: boolean) {
			
			this.displayPaymentMethods(partialInvoiceItem, isChecked)

			let isValid = true;
			let customerId = 0;
			const selected = this.combinedSplitParties.filter(x => x.IsSelected && !x.IsBilled)?.length ?? 0;
			this.isIndeterminate = selected > 0 && selected < this.unbilledSplitPartiesCount;
			this.isAllPartiesSelected = selected === this.unbilledSplitPartiesCount;
			if (Array.isArray(this.combinedSplitParties) && this.combinedSplitParties.length > 0) {
				this.combinedSplitParties.forEach(
					(m:any) => {
						if (isValid && (m.SplitPartyTypeName !== SPLIT_PARTIES.Individual
				&& (m.SplitPartyTypeName === SPLIT_PARTIES.Corporate || m.SplitPartyTypeName === SPLIT_PARTIES.Insurance))
						&& m.IsSelected) {
							isValid = true;
							customerId = m.CustomerId;
						} else if (m.SplitPartyTypeName === SPLIT_PARTIES.Individual && m.IsSelected) {
							isValid = false;
							customerId = m.CustomerId;
						}
					},
				);
			}	
			this.startLoading();
			const { data } = await apiProvider.getCustomerIdentifier(customerId);
			this.endLoading();
			this.CustomerIdentifier = data;
			if (this.dmsSys.EGUISplitPrp && this.isNotProforma) {
				if (this.combinedPartiesSelected.filter(x => x.IsSelected && !x.IsBilled)?.length > 1) {
					this.isSplitAllowed = false;
					showAlert({
						message: this.LocalizeChyboveHlasky('eGUISplitSingle'),
						title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
						options: { type: 'info' },
					});
				} else {
					this.isSplitAllowed = true;
				}
			}
		},

		displayPaymentMethods(partialInvoiceItem : IPartialInvoice, isChecked: boolean) {
			if(this.isBillingScreen && !this.isCreditNote) {
				const isNormalCustomer: boolean = partialInvoiceItem.SplitPartyTypeName === SPLIT_PARTIES.Individual || partialInvoiceItem.SplitPartyTypeName === SPLIT_PARTIES.Corporate || partialInvoiceItem.SplitPartyTypeName === SPLIT_PARTIES.Insurance;

				const selectedItems = this.combinedSplitParties.filter(item => item.IsSelected && !item.IsBilled &&
											(item.SplitPartyTypeName === SPLIT_PARTIES.Individual || item.SplitPartyTypeName === SPLIT_PARTIES.Corporate || item.SplitPartyTypeName === SPLIT_PARTIES.Insurance));

				if(isNormalCustomer === true) { 					 
					if(selectedItems.length > 1) {
						this.showErrorAlert({ message: this.LocalizeChyboveHlasky('CUSTOMER_SELECTION_MESSAGE') });						
						partialInvoiceItem.IsSelected = false;
						return;
					}
									
					if(isChecked === false && selectedItems.length == 0) {
						this.resetPaymentMethodDetails();
						return;
					}
					if(selectedItems.length == 1 && isChecked === false) {
						this.showErrorAlert({ message: this.LocalizeChyboveHlasky('CUSTOMER_SELECTION_MESSAGE') });						
						partialInvoiceItem.IsSelected = false;
						return;
					}

					this.isPaymentMethodApplicable = true;	
					this.InvoicePartTotal = partialInvoiceItem.PartTotal;
					this.PaymentPartTotal = partialInvoiceItem.PartTotal;
					this.InvoiceLaborTotal = partialInvoiceItem.LaborTotal;
					this.PaymentLaborTotal = partialInvoiceItem.LaborTotal;
					this.InvoiceTotalAmount = partialInvoiceItem.PartTotal + partialInvoiceItem.LaborTotal;
					if (partialInvoiceItem.CustomerId === this.ZakaznikId) {
						this.PaymentAdvancePayment = this.AdvanceAmount;
						this.PaymentTotalAmount = (this.InvoiceTotalAmount ?? 0) - (this.AdvanceAmount ?? 0);
					} else {
						this.PaymentAdvancePayment = 0;
						this.PaymentTotalAmount = this.InvoiceTotalAmount;
					}
				} else {
					if(selectedItems.length == 1) {
						this.isPaymentMethodApplicable = true; 
					}
					else {
						this.resetPaymentMethodDetails();
					}
				}
			}
		},

		async oneGUITypeValueUpdate() {
			this.rdbCarrier = this.cinCarrier;
		},
		onValueUpdate(isSelected: boolean): void {
			this.combinedSplitParties.filter(x => !x.IsCreditNote && !x.IsBilled
				&& (x.OverAllLineItemCompletionStatus || !this.isNotProforma)).map(x => { x.IsSelected = isSelected; return { ...x }; });
			this.isAllPartiesSelected = isSelected;
			this.isIndeterminate = false;
			if (this.dmsSys.EGUISplitPrp && this.isNotProforma) {
				if (this.combinedPartiesSelected.filter(x => x.IsSelected && !x.IsBilled)?.length > 1) {
					this.isSplitAllowed = false;
					showAlert({
						message: this.LocalizeChyboveHlasky('eGUISplitSingle'),
						title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
						options: { type: 'info' },
					});
				} else {
					this.isSplitAllowed = true;
				}
			}
		},
		formattedDate(date: string | null): string {
			return formatDate(date) ?? '';
		},
		getSplitPartyTypeLabel(index: number): string {
			if (index > PRIMARY_CUSTOMER_SPLIT_INDEX) {
				return '';
			}
			return this.LocalizePopisostatni('lblZakaznik');
		},
		call(method:any, args:any) {
			(this as { [key:string]:any })[method](args as any);
		},
		getLocalizedLabel(key: string) {
			return this.LocalizePopisostatni(`PI_${key}`);
		},
		showRejectedReasonsDialogForDD() {
			this.showRejectedReasonsDialog = true;
		},
		async default() {
            const fakturaceDto = {
                    zakazkaId: this.props.filter.zakazkaId,
                    dokladNaplnFakturaci: this.props.filter.dokladNaplnFakturaci,
					dokladId: this.props.filter.dokladId
            };
            const servicePromise = apiProvider.servisDefault(fakturaceDto);
            return this.$store.dispatch(`${this.storeUri}/DEFAULT`, servicePromise);
        },
		spocitejSplatnost() {
			if (this.platba === null) return;

			if (this.platba?.SplatnostPrp) {
				this.SplatnostDoba = this.subjectSplatnostDoba!.SplatnostDoba;
				this.SplatnostDate = dayJs(this.today).add(this.SplatnostDoba!, 'day').toDate();

				if (!this.IsOprava && !this.isVrubopis) {
					this.DuzpDate = this.today;
				}
			} else {
				this.SplatnostDoba = 0;
				this.SplatnostDate = this.today;
				if (!this.IsOprava && !this.isVrubopis) {
					this.DuzpDate = this.today;
				}
			}
		},
		filtrujPokladne() {
			if (this.UzivatelDefaultPokladnaId && this.isEnabledUserPokladna) {
				this.PokladnaId = this.UzivatelDefaultPokladnaId;
			}
		},
		async fetchPdfProvider() {
			const StartTime = performance.now();
			let documents =  await this.getFakturace();
			let iTotalTimeTaken = performance.now() - StartTime;
			let seconds = parseFloat((iTotalTimeTaken / 1000).toFixed(2));
			await apiProvider.logPerformance('CfdPrp', 'Proforma/Invoice', 'Load', seconds); 
			return documents;
		},
		async getFakturace() {
			try {
				let faktura: any;
				if (this.dmsSys.GenerateQuotationPrp) {
					switch (this.DokladNaplnFakturaci) {
						case DokladNaplnFakturaci.SALE_QUOTE:
							faktura = await apiProvider.partSalesQuoteReport(this.edit, this.nahled);
							if (!this.nahled) {
								await orderApiProvider.archiveParts(this.ZakazkaId!);
							}
							return faktura;
						case DokladNaplnFakturaci.QUICK_ESTIMATE:
							faktura = await apiProvider.quickEstimateReport(this.edit, this.nahled);
							if (!this.nahled) {
								await orderApiProvider.archiveParts(this.ZakazkaId!);
							}
							return faktura;
					}
					if (this.edit.FakturaceSubject === TypPrijemceFaktury.DEALERSHIP) {
						this.edit.DokladDruh = 'I';
					}
					if (this.isSplitPartyBillingEligible) {
						this.setPartialInvoiceList();
					}
					if (this.dmsSys.IndiaCFDPrp) {
						this.reportType = this.DokladDruh!;
						faktura = await apiProvider.invoiceReport(this.edit, this.nahled);
					} else {
						faktura = await apiProvider.tvorbaFaktury(this.edit, this.nahled);
					}
				} else {
					if (this.edit.FakturaceSubject === TypPrijemceFaktury.DEALERSHIP) {
						this.edit.DokladDruh = 'I';
					}
					this.isMarkAsPrint = !this.nahled;
					faktura = await apiProvider.tvorbaFaktury(this.edit, this.nahled);
				}
				if (this.isExternal && this.externalOpener!.host) {
					const multipartRawData = await faktura.data.arrayBuffer();
					const boundary = getBoundary(faktura.headers['content-type']);
					if (boundary) {
						const parts = parseMultipart(Buffer.from(multipartRawData), boundary);
						const [, dokladId] = parts[0].header.filename.split(/[_.]+/);
						window.parent.postMessage(`fakturace-doklad-id@${dokladId}`, this.externalOpener!.host);
					}
				}
				if (_.isArray(faktura)) {
					const { Message } = _.last(faktura);
					const questionResult = await this.showConfirm({
						title: this.LocalizePopisostatni('CRMDotaz'),
						message: this.Localize(Message),
						options: {
							confirmButtonText: this.Localize('Ano'),
							cancelButtonText: this.Localize('Ne'),
						},
					});
					if (questionResult) {
						this.PlatbaLimitConfirmed = true;
						//return apiProvider.tvorbaFaktury(this.edit, this.nahled);
					}
					this.showTiskDialog = false;
				}
				return faktura;
			} catch (e) {
				this.logError(e as Error);
			}
			return null;
		},
		async fakturuj(nahled = true) {
			if (!nahled) {
				this.isBillingButtonClicked = true;
				if (!this.isSelectAllVisible && !this.isCreditNote && this.getSelectedNormalCustomers()?.length > 0) {
					if (await this.validateNonDeductiblePaymentAmount() == false || await this.onDeductiblePaymentChange() == false) {
						this.isBillingButtonClicked = false;
						return;
					}
				}
			}
			this.edit.PartialInvoices = null;
			if (this.isSplitPartyBillingEligible) {
				if (!this.isBillingSelectionValid()) {
					showAlert({
						message: this.LocalizeChyboveHlasky('BillingInvalidSelection'),
						title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
						options: { type: 'info' },
					});
					return;
				}
				if (this.canBillWarranty() && !this.isCreditNote) {
					this.isSagaProcessed = await this.checkSagaStatus();
					if (!this.isSagaProcessed) {
						this.isBillingButtonClicked = false;
						const statusMessage = this.sagaStatusMessage ? `Additional Details - ${this.sagaStatusMessage}` : '';						
						showAlert({
							message: `${this.LocalizeChyboveHlasky('WarrantySagaValidation')} ${statusMessage}`,
							title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
							options: { type: 'info' },
						});
						return;
					}
				}
				this.setPartialInvoiceList();
			}
			if (nahled) {
				this.isMarkAsPrint = true;
				this.edit.IsProformaCreated = true;
			} else {
				this.isMarkAsPrint = false;
				if (this.dmsSys.EnableGSTPrp && this.DokladDruh !== ZAKAZKA_DRUH.PRODEJ_PULT && this.ZakaznikId !== null) {
					const { data: isUserGstRegistered } = await apiProvider.isUserGstRegistered(this.ZakaznikId!);
					if (isUserGstRegistered) {
						showAlert({
							message: this.LocalizePopisostatni('InvoicProcessing'),
							title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
							options: { type: 'info' },
						});
					}
				}
			}
			if (!nahled) {
				if (this.dmsSys.IsCancelInvoicePrp) {
					if (this.DokladNaplnFakturaci === DokladNaplnFakturaci.DOBROPIS) {
						switch (this.props.filter.statusId) {
							case ApproverStatus.APPROVE:
								showAlert({
									message: this.LocalizeChyboveHlasky('msgRevJobOrderComplete'),
									title: this.LocalizeChyboveHlasky('errorTitle'),
									options: {
										type: 'error',
										closeOnPressEscape: true,
										closeOnClickModal: true,
									},
								});
								return;
							case ApproverStatus.REJECT:
								showAlert({
									message: this.LocalizeChyboveHlasky('msgRevJobOrderComplete'),
									title: this.LocalizeChyboveHlasky('errorTitle'),
									options: {
										type: 'error',
										closeOnPressEscape: true,
										closeOnClickModal: true,
									},
								});
								return;
							case ApproverStatus.SUBMITTED:
								showAlert({
									message: this.LocalizeChyboveHlasky('msgRevJobOrderReqSubmit'),
									title: this.LocalizeChyboveHlasky('errorTitle'),
									options: {
										type: 'error',
										closeOnPressEscape: true,
										closeOnClickModal: true,
									},
								});
								return;
						}
						this.startLoading();
						const reverseJobOrderResponse = await reverJobOrderApi.isReverseJobOrderExists(this.DokladId);
						if (this.ZakaznikId!) {
							this.oemApprovaldata = await pratnerApiProvider.getOemApproval(this.ZakaznikId!);
						}

						this.endLoading();
						if (reverseJobOrderResponse.data.length > 0 && reverseJobOrderResponse.data[reverseJobOrderResponse.data.length - 1].RequestStatusId === ApproverStatus.SUBMITTED) {
							showAlert({
								message: this.LocalizeChyboveHlasky('msgRevJobOrderReqSubmit'),
								title: this.LocalizeChyboveHlasky('errorTitle'),
								options: {
									type: 'error',
									customClass: 'message-box--max-content-width message-box--top-aligned-icon',
									closeOnPressEscape: true,
									closeOnClickModal: true,
								},
							});
							return;
						}
						if (reverseJobOrderResponse.data.length > 0 && reverseJobOrderResponse.data[reverseJobOrderResponse.data.length - 1].RequestStatusId === ApproverStatus.APPROVE) {
							showAlert({
								message: this.LocalizeChyboveHlasky('msgRevJobOrderComplete'),
								title: this.LocalizeChyboveHlasky('errorTitle'),
								options: {
									type: 'error',
									closeOnPressEscape: true,
									closeOnClickModal: true,
								},
							});
							return;
						}
						if (this.oemApprovaldata.data === true) {
							// Area Manager Approval
							const questionResult = await this.showConfirm({
								title: this.LocalizeChyboveHlasky('msgApprovalReqForCancel'),
								message: this.LocalizeChyboveHlasky('errorTitle'),
								options: {
									confirmButtonText: this.Localize('Ano'),
									cancelButtonText: this.Localize('Ne'),
								},
							});
							if (questionResult) {
								const postData = {
									OrderId: this.ZakazkaId,
									InvoiceId: this.DokladId,
									CreatedById: this.pracovnik.PracovnikId,
									RequestStatusId: 2,
									ApprovalRemarks: this.LocalizePopisostatni('PartReturnRequestRemarks'),
									Remark: this.Remark,
								};
								this.startLoading();
								let areamMangerApproval = await reverJobOrderApi.getWorkflowApprovalConfig('AreaManagerApproval', 'User');
								if (areamMangerApproval.data.length <= 0) {
									areamMangerApproval = await reverJobOrderApi.getWorkflowApprovalConfig('AreaManagerApproval', 'Role');
								}
								if (areamMangerApproval.data.length <= 0)	{
									showAlert({
										message: this.LocalizeChyboveHlasky('msgApprovalReqForCancel'),
										title: this.LocalizeChyboveHlasky('errorTitle'),
										options: {
											type: 'error',
											closeOnPressEscape: true,
											closeOnClickModal: true,
										},
									});
									this.endLoading();
									return;
								}
								if (areamMangerApproval.data.length > 0) {
									await reverJobOrderApi.insertData(postData);
									if (this.dmsSys.SendMailNotificationPrp) {
										const notificationObj = {
										SenderId: this.pracovnik.PracovnikId,
										ReceiverId: areamMangerApproval.data[0].PRIMARY_APPROVAL_ID,
										NotificationMsg: this.buildNotificationMsg(),
										};
										await partReturnsApiProvider.sendNotification(notificationObj);
									}
									this.endLoading();
									return;
								}
								this.endLoading();
								return;
							}
							this.endLoading();
							return;
						}

						this.startLoading();
						let IsApprover = false;
						let dealerApprovalData = await reverJobOrderApi.getWorkflowApprovalConfig('DealerManagerAp', 'User');
						this.endLoading();
						if (dealerApprovalData.data.length <= 0) {
							this.startLoading();
							dealerApprovalData = await reverJobOrderApi.getWorkflowApprovalConfig('DealerManagerAp', 'Role');
							this.endLoading();
							if (dealerApprovalData.data.length > 0) {
								IsApprover = true;
							}
						} else {
							IsApprover = true;
						}
						if (!IsApprover)	{
							showAlert({
								message: this.LocalizeChyboveHlasky('msgSetupDealerData'),
								title: this.LocalizeChyboveHlasky('errorTitle'),
								options: {
									type: 'error',
									closeOnPressEscape: true,
									closeOnClickModal: true,
								},
							});
							return;
						}

						const questionResult = await this.showConfirm({
							title: this.LocalizeChyboveHlasky('msgApprovalReqForCancel'),
							message: this.LocalizeChyboveHlasky('errorTitle'),
							options: {
								confirmButtonText: this.Localize('Ano'),
								cancelButtonText: this.Localize('Ne'),
							},
						});
						if (questionResult) {
							const postData = {
								OrderId: this.ZakazkaId,
								InvoiceId: this.DokladId,
								CreatedById: this.pracovnik.PracovnikId,
								RequestStatusId: 2,
								ApprovalRemarks: this.LocalizePopisostatni('PartReturnRequestRemarks'),
								Remark: this.Remark,
							};

							this.startLoading();
							await reverJobOrderApi.insertData(postData);
							if (this.dmsSys.SendMailNotificationPrp) {
								const NotificationObj = {
									SenderId: this.pracovnik.PracovnikId,
									ReceiverId: dealerApprovalData.data[0].PRIMARY_APPROVAL_ID,
									NotificationMsg: this.buildNotificationMsg(),
								};
								await partReturnsApiProvider.sendNotification(NotificationObj);
								this.endLoading();
								return;
							}
						}
						this.endLoading();

						return;
					}
				}
			}
			this.nahled = nahled;
			this.showTiskDialog = true;
			if (this.nahled) this.isMarkAsPrint = false;
		},
		buildNotificationMsg(): string {
			let sNotificationMsg;
			sNotificationMsg = this.LocalizeAndReplace(this.LocalizePopisostatni('PartReturnRequestRemarks'), { key: '<CR_NO>', value: this.props.filter.CRNo! });
			sNotificationMsg = this.LocalizeAndReplace(sNotificationMsg, { key: '<CUST_NAME>', value: this.pracovnik.Jmeno! });
			return sNotificationMsg;
		},
		async approveReverseJobOrder(nahled = true) {
			const postData = {
				Id: this.props.filter.rrId,
				CreatedById: this.props.filter.createdById,
				UpdatedById: this.pracovnik.PracovnikId,
				RequestStatusId: 1,
				ApprovalRemarks: this.Remark,
				Remark: this.Remark,
				OrderId: this.ZakazkaId,
				InvoiceId: this.DokladId,
			};
			this.startLoading();
			const approveResponse = await reverJobOrderApi.approveReturnRequest(postData);
			if (approveResponse.data.Value === -1) {
				this.endLoading();
				return;
			}
			const notificationObj = {
				SenderId: this.pracovnik.PracovnikId,
				ReceiverId: this.props.filter.createdById,
				NotificationMsg: this.LocalizeAndReplace(this.LocalizeAndReplace(this.LocalizePopisostatni('ReverseJobApprovedNot'),
					{ key: '<CR_NO>', value: this.props.filter.CRNo! }), { key: '<CUST_NAME>', value: this.pracovnik.Jmeno! }),
			};
			await partReturnsApiProvider.sendNotification(notificationObj);
			
			const { data: shouldDisplayCreditNotePopUp}  = await apiProvider.getCreditNotePopUpStatus(this.DokladId!);
			if(shouldDisplayCreditNotePopUp) {
				const questionResult = await this.showConfirm({
										title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
										message: this.LocalizeChyboveHlasky('PART_ISSUE_CONFIRM_MESSAGE'),
										options: {
											showClose: false,
											closeOnClickModal:false,
											closeOnPressEscape:false,
											confirmButtonText: this.Localize('Ano'),
											cancelButtonText: this.Localize('Ne'),
										},
								});
								if (questionResult) {
									this.edit.IsPartIssueConfirmed = true;
								}
			}
			this.endLoading();
			this.nahled = nahled;
			this.showTiskDialog = true;
			this.isCreditNoteApproved = true;
			this.isApproveButtonClicked = true;
			this.refreshPreviousPage = true;
		},
		async rejectReverseJobOrder() {
			if (this.Remarks === null || this.Remarks === '' || this.ReasonId === null) {
				this.showErrorAlert({
					message: this.LocalizeChyboveHlasky('RemarkAndReasonRequired'),
					localizeMessage: false,
				});
				return;
			}

			this.showRejectedReasonsDialog = false;
			this.isRejectButtonClicked = true;
			const postData = {
				Id: this.props.filter.rrId,
				CreatedById: this.props.filter.createdById,
				UpdatedById: this.pracovnik.PracovnikId,
				RequestStatusId: 3,
				ApprovalRemarks: this.Remark,
				RejectedReasonId: this.ReasonId,
				RejectedRemarks: this.Remarks,
				Remark: this.Remark,
				OrderId: this.ZakazkaId,
				InvoiceId: this.DokladId,
			};
			this.startLoading();
			const rejectResponse = await reverJobOrderApi.approveReturnRequest(postData);
			if (rejectResponse.data.Value === -1) {
				this.endLoading();
				return;
			}
			this.Remarks = null;
			this.ReasonId = null;
			let NotificationMsg = this.LocalizeAndReplace(this.LocalizeChyboveHlasky('ReverseJobRejectNot'), { key: '<CR_NO>', value: this.props.filter.CRNo! });
			NotificationMsg = this.LocalizeAndReplace(NotificationMsg, { key: '<CUST_NAME>', value: this.pracovnik.Jmeno! });
			const NotificationObj = {
				SenderId: this.pracovnik.PracovnikId,
				ReceiverId: this.props.filter.createdById,
				NotificationMsg,
			};
			await partReturnsApiProvider.sendNotification(NotificationObj);
			this.endLoading();
			openList('ReverseJobOrder');
			this.refreshPreviousPage = true;
		},
		reklamniTextRowSelection({ row }: any) {
			this.ReklamniTextId = row.REKLTXT_ID;
			this.ReklamniTextIdText = `${row.REKL_TEXT1}\n${row.REKL_TEXT2}`;
		},
		reklamnyTextVyberClick() {
			openSelectList(ReklamaText.name, {
				afterRowSelection: this.reklamniTextRowSelection,
			});
		},
		async printDialogClosed() {
			if (!this.nahled && this.DokladNaplnFakturaci !== DokladNaplnFakturaci.PRO_FORMA && !this.isCreditNoteApproved!) {
				const { data } = await apiProvider.validateAndCloseOrder(this.ZakazkaId);
				const isInvoiced = await this.checkEGUIEnabledForInvoicedCustomer();
				if (this.IsGUIEnabled && (this.isEGUIOptionAvailable) && isInvoiced) {
					this.iseGUIIssuePopUpVisible = true;
					this.iseGUIApplicable = true;
					this.lbleGUI = EGUI_OPTIONS.EGUI_ISSUE;
					this.firstEguiCustomerName = this.getCustomerEguiSplit('FIRST_INVOICE');
					this.secondEguiCustomerName = this.getCustomerEguiSplit('SECOND_INVOICE');
				} else {
					this.recomputeHash();
					this.refreshPreviousPage = true;
					this.$router.go(-2); // TODO: JK - kontrolovat kam sa vraciam - zatial predpokladam navrat na list zakazok.
				}
			} else if (this.DokladNaplnFakturaci === DokladNaplnFakturaci.PRO_FORMA) {
				this.recomputeHash();
				this.$router.go(-1);
			} else if ((this.EGUIInvoiceNumber !== '' && this.EGUIInvoiceNumber !== null
				&& this.EGUISelectedInvoiceNumber !== null && this.EGUISelectedInvoiceNumber !== '')
				&& this.isCreditNoteApproved && this.IsGUIEnabled && this.isEGUIOptionAvailable && this.isEguiCanceled) {
				this.isEguiCanceled = false;
				this.eGUICancelInvoice();
			} else if (this.isCreditNoteApproved && this.IsGUIEnabled && this.isEguiCanceled) {
				this.isEguiCanceled = false;
				this.recomputeHash();
				this.$router.go(-1);
			}
		},
		printInsuranceBillReport() {
			this.tiskDialog.fetchPdfProvider = () => apiProvider.getInsuranceBillReport(this.edit, true);
			this.tiskDialog.visible = true;
		},
		printCustomerBillReport() {
			this.isMarkAsPrint = true;
			this.reportType = 'SCBC';
			this.tiskDialog.fetchPdfProvider = () => apiProvider.getCustomerBillReport(this.edit, true);
			this.tiskDialog.visible = true;
		},
		printCustomerSalesInvoiceReport() {
			this.isMarkAsPrint = true;
			this.reportType = 'CSI';
			this.tiskDialog.fetchPdfProvider = () => apiProvider.getCustomerSalesInvoiceReport(this.edit, true);
			this.tiskDialog.visible = true;
			this.isMarkAsPrint = true;
		},
		printWarrantyInvoiceReport() {
			this.reportType = REPORT_TYPE.WARRANTY_INVOICE;
			this.tiskDialog.fetchPdfProvider = () => apiProvider.getWarrantyInvoiceReport(this.edit, true);
			this.tiskDialog.visible = true;
			this.isMarkAsPrint = true;
		},
		async markReportAsPrint() {
			if (this.isMarkAsPrint) {
				apiProvider.markReportAsPrint(this.ZakazkaId, this.reportType);
			}
			if (!this.nahled && this.DokladNaplnFakturaci !== DokladNaplnFakturaci.PRO_FORMA && !this.isCreditNoteApproved!) {				
				const { data } = await apiProvider.validateAndCloseOrder(this.ZakazkaId);
				if (this.isEGUIOptionAvailable){
				const isInvoiced = await this.checkEGUIEnabledForInvoicedCustomer();
					if (isInvoiced) {
						this.iseGUIIssuePopUpVisible = true;
						this.iseGUIApplicable = true;
						this.lbleGUI = EGUI_OPTIONS.EGUI_ISSUE;
						this.firstEguiCustomerName = this.getCustomerEguiSplit('FIRST_INVOICE');
						this.secondEguiCustomerName = this.getCustomerEguiSplit('SECOND_INVOICE');
					}
				}
			} else if ((this.EGUIInvoiceNumber !== '' && this.EGUIInvoiceNumber !== null && this.EGUISelectedInvoiceNumber !== null && this.EGUISelectedInvoiceNumber !== '')
            && this.isCreditNoteApproved && this.IsGUIEnabled && this.isEGUIOptionAvailable && this.isEguiCanceled) {
				this.isEguiCancelPopupVisible = true;
				this.isEguiCanceled = false;
			}
		},

		async onPrintCustomerSatisfactiontNote() {
			this.reportType = REPORT_TYPE.CUSTOMER_SATISFACTION;
			this.isMarkAsPrint = true;
			this.tiskDialog.fetchPdfProvider = () => apiProvider.getCustomerStatisfactionNote({ Id: this.props.filter.zakazkaId });
			this.tiskDialog.visible = true;
		},
		onWarrantyOkClick() {
			this.dmsSys.WarrantyPrp = false;
			this.onPrintCustomerSatisfactiontNote();
		},
		isBillingSelectionValid(): boolean {
			return this.combinedSplitParties.some(x => x.IsSelected);
		},
		canBillWarranty(): boolean {
			return this.combinedSplitParties.some(x => x.IsSelected && (x.SplitPartyTypeId === SplitPartyType.Warranty || x.SplitPartyTypeId === SplitPartyType.Goodwill));
		},
		setPartialInvoiceList(): void {
			this.edit.PartialInvoices = [];
			this.edit.PartialInvoices = this.combinedSplitParties.filter(x => x.IsSelected && ((!x.IsBilled && (x.OverAllLineItemCompletionStatus || !this.isNotProforma))
				|| (x.IsBilled)));
		},
		async onSplitItemAmtChange(item: any) {
			if (this.combinedPartiesSelected[0].IsPartsAvailable && this.combinedPartiesSelected[0].IsLOAvailable) {
				if (((parseFloat(_.defaultTo(item.PartsAmount, 0).toString()) + parseFloat(_.defaultTo(item.LaborAmount, 0).toString())) < item.ActualShareTotalPayment)
				&& item.PartsAmount > 0 && item.LaborAmount > 0) {
					this.showErrorAlert({
						title: this.LocalizeChyboveHlasky('DMS3_ErrorTitle'),
						message: `${item.eGUISplitPartyTypeName} ${': '} ${this.LocalizeChyboveHlasky('eGUISplitItemsTot')}`,
						options: { type: 'error' },
					});
					return false;
				} else if (((parseFloat(_.defaultTo(item.PartsAmount, 0).toString()) + parseFloat(_.defaultTo(item.LaborAmount, 0).toString())) < item.ActualShareTotalPayment)
				&& (item.PartsAmount <= 0 || item.LaborAmount <=0)) {
					return true;
				} else if ((parseFloat(_.defaultTo(item.PartsAmount, 0).toString()) + parseFloat(_.defaultTo(item.LaborAmount, 0).toString())) != item.ActualShareTotalPayment) {
					this.showErrorAlert({
						title: this.LocalizeChyboveHlasky('DMS3_ErrorTitle'),
						message: `${item.eGUISplitPartyTypeName} ${': '} ${this.LocalizeChyboveHlasky('eGUISplitItemsTot')}`,
						options: { type: 'error' },
					});
					return false;
				} else {
					return true;
				}
			} else if (this.combinedPartiesSelected[0].IsPartsAvailable && !this.combinedPartiesSelected[0].IsLOAvailable) {
				if (parseFloat(_.defaultTo(item.PartsAmount, 0).toString()) != item.ActualShareTotalPayment) {
					this.showErrorAlert({
						title: this.LocalizeChyboveHlasky('DMS3_ErrorTitle'),
						message: `${item.eGUISplitPartyTypeName} ${': '} ${this.LocalizeChyboveHlasky('eGUISplitItemNDTot')}`,
						options: { type: 'error' },
					});
					return false;
				} else {
					return true;
				}
			} else if (!this.combinedPartiesSelected[0].IsPartsAvailable && this.combinedPartiesSelected[0].IsLOAvailable) {
				if (parseFloat(_.defaultTo(item.LaborAmount, 0).toString()) != item.ActualShareTotalPayment) {
					this.showErrorAlert({
						title: this.LocalizeChyboveHlasky('DMS3_ErrorTitle'),
						message: `${item.eGUISplitPartyTypeName} ${': '} ${this.LocalizeChyboveHlasky('eGUISplitItemPPTot')}`,
						options: { type: 'error' },
					});
					return false;
				} else {
					return true;
				}
			}
		},
		async onSharePercChange(item: any) {
			if (!Number.isNaN(item.SharePercentage) && (item.SharePercentage > 0)) {
				if (item.SharePercentage != item.OldSharePercentage) {
					item.PartsAmount = 0;
					item.LaborAmount = 0;
					item.CashAmount = 0;
					item.CreditAmount = 0;
					item.DebitAmount = 0;
					item.OnlineAmount = 0;
					item.AdvanceTotalPayment = 0;
				}
				if (Number.isNaN(item.SharePercentage) || (item.SharePercentage < 0 || item.SharePercentage > 100)) {
					this.showErrorAlert({
						title: this.LocalizeChyboveHlasky('DMS3_ErrorTitle'),
						message: this.LocalizeChyboveHlasky('SB_eGUI_Val_Percent'),
						options: { type: 'error' },
					});
					item.SharePercentage = 0;
					item.ShareAmount = 0;
					return false;
				} else {
					item.OldSharePercentage = item.SharePercentage;
					item.ActualShareTotalPayment = Math.round((item.ActualTotalPayment * item.SharePercentage) / 100);
					item.ShareAmount = 0;
					const otherSplitItem = this.arrayeGUISplitDetails.filter(x => x.eGUISplitPartyTypeId != item.eGUISplitPartyTypeId)[0];
					if (this.arrayeGUISplitDetails.indexOf(otherSplitItem) > -1) {
						this.arrayeGUISplitDetails[this.arrayeGUISplitDetails.indexOf(otherSplitItem)].SharePercentage = 100 - item.SharePercentage;
						this.arrayeGUISplitDetails[this.arrayeGUISplitDetails.indexOf(otherSplitItem)].ActualShareTotalPayment =
							// Math.round((this.arrayeGUISplitDetails[this.arrayeGUISplitDetails.indexOf(otherSplitItem)].ActualTotalPayment * this.arrayeGUISplitDetails[this.arrayeGUISplitDetails.indexOf(otherSplitItem)].SharePercentage) / 100);
							Math.round(this.arrayeGUISplitDetails[this.arrayeGUISplitDetails.indexOf(otherSplitItem)].ActualTotalPayment - item.ActualShareTotalPayment);
						this.arrayeGUISplitDetails[this.arrayeGUISplitDetails.indexOf(otherSplitItem)].ShareAmount = 0;
						this.arrayeGUISplitDetails[this.arrayeGUISplitDetails.indexOf(otherSplitItem)].OldSharePercentage = this.arrayeGUISplitDetails[this.arrayeGUISplitDetails.indexOf(otherSplitItem)].SharePercentage;
					}
				}
			}
		},
		async onShareAmtChange(item: any) {
			if (!Number.isNaN(item.ShareAmount) && (item.ShareAmount > 0)) {
				if (item.ShareAmount != item.OldShareAmount) {
					item.PartsAmount = 0;
					item.LaborAmount = 0;
					item.CashAmount = 0;
					item.CreditAmount = 0;
					item.DebitAmount = 0;
					item.OnlineAmount = 0;
					item.AdvanceTotalPayment = 0;
				}
				if (Number.isNaN(item.ShareAmount) || item.ShareAmount < 0 || item.ShareAmount > item.ActualTotalPayment) {
					this.showErrorAlert({
						title: this.LocalizeChyboveHlasky('DMS3_ErrorTitle'),
						message: this.LocalizeChyboveHlasky('SB_Zero_Amt_Percent'),
						options: { type: 'error' },
					});
					item.ShareAmount = 0;
					item.SharePercentage = 0;
					return false;
				} else {
					item.OldShareAmount = item.ShareAmount;
					item.ActualShareTotalPayment = Math.round(item.ShareAmount);
					item.SharePercentage = 0;
					const otherSplitItem = this.arrayeGUISplitDetails.filter(x => x.eGUISplitPartyTypeId != item.eGUISplitPartyTypeId)[0];
					if (this.arrayeGUISplitDetails.indexOf(otherSplitItem) > -1) {
						this.arrayeGUISplitDetails[this.arrayeGUISplitDetails.indexOf(otherSplitItem)].ShareAmount =
						this.arrayeGUISplitDetails[this.arrayeGUISplitDetails.indexOf(otherSplitItem)].ActualTotalPayment - item.ShareAmount;
						this.arrayeGUISplitDetails[this.arrayeGUISplitDetails.indexOf(otherSplitItem)].ActualShareTotalPayment =
							Math.round(this.arrayeGUISplitDetails[this.arrayeGUISplitDetails.indexOf(otherSplitItem)].ActualTotalPayment - item.ShareAmount);
						this.arrayeGUISplitDetails[this.arrayeGUISplitDetails.indexOf(otherSplitItem)].SharePercentage = 0;
						this.arrayeGUISplitDetails[this.arrayeGUISplitDetails.indexOf(otherSplitItem)].OldShareAmount = this.arrayeGUISplitDetails[this.arrayeGUISplitDetails.indexOf(otherSplitItem)].ShareAmount;
					}
				}
			}
		},
		async onAmountChange(item: any, bPaymentMethod: number) {
			switch (bPaymentMethod) {
				case EGUI_PAYMENT_VALIDATION.CASH:
					if (Number.isNaN(parseFloat(_.defaultTo(item.CashAmount, 0).toString()))) {
						item.AdvanceTotalPayment = parseFloat(_.defaultTo(item.CreditAmount, 0).toString()) + parseFloat(_.defaultTo(item.DebitAmount, 0).toString())
						+ parseFloat(_.defaultTo(item.OnlineAmount, 0).toString());
					} else {
						item.AdvanceTotalPayment = parseFloat(_.defaultTo(item.CashAmount, 0).toString()) + parseFloat(_.defaultTo(item.CreditAmount, 0).toString())
						+ parseFloat(_.defaultTo(item.DebitAmount, 0).toString()) + parseFloat(_.defaultTo(item.OnlineAmount, 0).toString());
					}
					break;
				case EGUI_PAYMENT_VALIDATION.CREDIT_CARD:
					if (Number.isNaN(parseFloat(_.defaultTo(item.CreditAmount, 0).toString()))) {
						item.AdvanceTotalPayment = parseFloat(_.defaultTo(item.CashAmount, 0).toString()) + parseFloat(_.defaultTo(item.DebitAmount, 0).toString())
						+ parseFloat(_.defaultTo(item.OnlineAmount, 0).toString());
					} else {
						item.AdvanceTotalPayment = parseFloat(_.defaultTo(item.CashAmount, 0).toString()) + parseFloat(_.defaultTo(item.CreditAmount, 0).toString())
						+ parseFloat(_.defaultTo(item.DebitAmount, 0).toString()) + parseFloat(_.defaultTo(item.OnlineAmount, 0).toString());
					}
					break;
				case EGUI_PAYMENT_VALIDATION.DEBIT_CARD:
					if (Number.isNaN(parseFloat(_.defaultTo(item.DebitAmount, 0).toString()))) {
						item.AdvanceTotalPayment = parseFloat(_.defaultTo(item.CashAmount, 0).toString()) + parseFloat(_.defaultTo(item.CreditAmount, 0).toString())
						+ parseFloat(_.defaultTo(item.OnlineAmount, 0).toString());
					} else {
						item.AdvanceTotalPayment = parseFloat(_.defaultTo(item.CashAmount, 0).toString()) + parseFloat(_.defaultTo(item.CreditAmount, 0).toString())
						+ parseFloat(_.defaultTo(item.DebitAmount, 0).toString()) + parseFloat(_.defaultTo(item.OnlineAmount, 0).toString());
					}
					break;
				case EGUI_PAYMENT_VALIDATION.ONLINE:
					if (Number.isNaN(parseFloat(_.defaultTo(item.OnlineAmount, 0).toString()))) {
						item.AdvanceTotalPayment = parseFloat(_.defaultTo(item.CashAmount, 0).toString()) + parseFloat(_.defaultTo(item.CreditAmount, 0).toString())
						+ parseFloat(item.DebitAmount.toString());
					} else {
						item.AdvanceTotalPayment = parseFloat(_.defaultTo(item.CashAmount, 0).toString()) + parseFloat(_.defaultTo(item.CreditAmount, 0).toString())
						+ parseFloat(_.defaultTo(item.DebitAmount, 0).toString()) + parseFloat(_.defaultTo(item.OnlineAmount, 0).toString());
					}
					break;
			}
		},
		getCustomerEguiSplit(eGUIInvoiceName: string): string {
			if (this.combinedPartiesSelected[0] !== null && this.combinedPartiesSelected[0] !== undefined) {
				return `${this.LocalizePopisostatni('lblZakaznik')}${' : '}${this.combinedPartiesSelected[0].CustomerName} ${this.LocalizePopisostatni(eGUIInvoiceName)}`;
			} else {
				return `${this.LocalizePopisostatni(eGUIInvoiceName)}`;
			}
		},
		getSplitPartyLabelEguiSplit(eGUISplitPartyTypeName: string): string {
			return `${this.LocalizePopisPoli('CARRIER')}${' : '}${eGUISplitPartyTypeName}`;
		},
		getLabelKeyForAmount(eGUIInvoiceName: string): string {
			return `${this.LocalizePopisostatni(eGUIInvoiceName)} ${this.LocalizePopisPoli('PAY_TOTAL')}`;
		},
		resetPaymentMethodDetails() {
			this.isPaymentMethodApplicable = false;
			this.InvoicePartTotal = 0;
			this.PaymentPartTotal = 0;
			this.InvoiceLaborTotal = 0;
			this.PaymentLaborTotal = 0;
			this.InvoiceTotalAmount = 0;
			this.PaymentTotalAmount = 0;
			this.PaymentAdvancePayment = 0;
			this.PaymentTotalAmount = 0;
			this.DPHandlingFee = 0;
			this.DPDealerDeduction = 0;
			this.DPOEMDeduction = 0;
			this.DPRoundOff = 0;
			this.CashPaymentAmount = 0;
			this.DebitPaymentAmount = 0;
			this.CreditPaymentAmount = 0;
			this.OnlinePaymentAmount = 0;
			this.AccountReceivableAmount = 0;
			this.TTPaymentAmount = 0;
			this.RemarkCashPaymentAmount = '';
			this.RemarkDebitPaymentAmount = '';
			this.RemarkCreditPaymentAmount = '';
			this.RemarkOnlinePaymentAmount = '';
			this.RemarkAccountReceivableAmount = '';
			this.RemarkTTPaymentAmount = '';
			this.RemarkDPDealerDeduction = '';
			this.RemarkDPHandlingFee = '';
			this.RemarkDPOEMDeduction = '';
			this.RemarkDPRoundOff = '';
		},
		async validatePayTotal() {
			if (!Number.isNaN(parseFloat(_.defaultTo(this.paytotal, 0).toString()))) {
				if (this.isSplitEligible) {
					if (this.paytotal > this.PaymentTotalAmount!) {
						this.showErrorAlert({
							title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
							message: `${this.LocalizeChyboveHlasky('eGUIFirstSplitTotalValidate').replace('@EGUIAMOUNT', (this.paytotal + this.paytotalSecond).toString())
								.replace('@INVAMOUNT', this.PaymentTotalAmount!.toString())}`,
							options: { type: 'info' },
						});
						this.paytotal = 0;
						return;
					} else if (this.paytotal <= 0) {
						this.showErrorAlert({
							title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
							message: `${this.LocalizeChyboveHlasky('eGUISplitTotalValidate')} ${':'} ${this.LocalizePopisostatni('FIRST_INVOICE')}`,
							options: { type: 'info' },
						});
						return;
					} else {
						this.paytotalSecond = this.PaymentTotalAmount! - this.paytotal;
					}
					if ((this.paytotal + this.paytotalSecond) !== this.PaymentTotalAmount!) {
						this.showErrorAlert({
							title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
							message: `${this.LocalizeChyboveHlasky('eGUIFirstSplitTotalValidate').replace('@EGUIAMOUNT', (this.paytotal + this.paytotalSecond).toString())
								.replace('@INVAMOUNT', this.PaymentTotalAmount!.toString())}`,
							options: { type: 'info' },
						});
						return;
					}
				} else {
					if (this.paytotal !== this.PaymentTotalAmount!) {
						this.showErrorAlert({
							title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
							message: `${this.LocalizeChyboveHlasky('eGUIFirstSplitTotalValidate').replace('@EGUIAMOUNT', this.paytotal.toString())
								.replace('@INVAMOUNT', this.PaymentTotalAmount!.toString())}`,
							options: { type: 'info' },
						});
						return;
					}
				}
			}
		},
		async onDeductiblePaymentChange() {
			const actualTotalAmount = (this.InvoicePartTotal! + this.InvoiceLaborTotal!) - this.PaymentAdvancePayment!;
			const deductionSum: number = this.DPHandlingFee + this.DPDealerDeduction + this.DPOEMDeduction + this.DPRoundOff;
			if (deductionSum > actualTotalAmount) {
				showAlert({
					message: this.LocalizeChyboveHlasky('DEDUCTIBLE_AMOUNT_VALIDATOIN_MSG'),
					title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
					options: { type: 'info' },
				});
				return false;
			}

			this.PaymentPartTotal = this.InvoicePartTotal;
			this.PaymentLaborTotal = this.InvoiceLaborTotal;
			this.PaymentTotalAmount = actualTotalAmount;
			this.paytotal = this.PaymentTotalAmount - deductionSum;
			
			if (this.PaymentPartTotal! > 0) {
				const remainingAmount = this.PaymentPartTotal! - deductionSum;
				if (remainingAmount < 0) {
					this.PaymentPartTotal! = 0;
					this.PaymentLaborTotal! += remainingAmount;
					this.PaymentTotalAmount = (this.PaymentPartTotal ?? 0)  + (this.PaymentLaborTotal ?? 0) - (this.PaymentAdvancePayment ?? 0); 
				} else {
					this.PaymentPartTotal! -= deductionSum;
				}
			} else {
				this.PaymentLaborTotal! -= deductionSum;
			}
			this.PaymentTotalAmount = (this.PaymentPartTotal ?? 0) + (this.PaymentLaborTotal ?? 0) - (this.PaymentAdvancePayment ?? 0);
			this.TotalDeductions = deductionSum;
			return true;
		},

		async validateNonDeductiblePaymentAmount() {
			const totalNonDeductibleAmount = this.edit.CashPaymentAmount + this.edit.CreditPaymentAmount + this.edit.DebitPaymentAmount + this.edit.AccountReceivableAmount + this.edit.TTPaymentAmount + this.edit.OnlinePaymentAmount;

			if (totalNonDeductibleAmount != this.edit.PaymentTotalAmount) {
				this.showErrorAlert({ message: this.LocalizeChyboveHlasky('INVALID_DEDUCTIBLE_PAYMENT_AMOUNT') });
				return false;
			}
			return true;
		},

		async onProceedClick() {
			if (this.isProceedClicked) {
				return;
			}
			this.isProceedClicked = true;
			this.isShoweGUISummary = false;
			this.iseGUIIssuePopUpVisible = false;
			await this.eGUIIssueSPlittedInvoice();
			this.isProceedClicked = false;
		},
		getFirstEGUISplitAmounts() {
			this.TotalFirstEGUIPartsAmount = 0;
			this.TotalFirstEGUILaborAmount = 0;
			this.FirstEGUIPartsAmount = 0;
			this.FirstEGUILaborAmount = 0;
			if (this.PartsTotalAmount <= 0 && this.InvoicePartTotal! > 0) {
				this.FirstEGUIPartsAmount = this.InvoicePartTotal!;
				if (this.PaymentAdvancePayment! > 0 && this.combinedPartiesSelected[0].CustomerId == this.ZakaznikId) {
					this.TotalFirstEGUIPartsAmount = this.FirstEGUIPartsAmount + this.PaymentAdvancePayment!;
				} else {
					this.TotalFirstEGUIPartsAmount = this.FirstEGUIPartsAmount;
				}
				if (this.LaborTotalAmount > 0) {
					this.TotalFirstEGUILaborAmount = this.paytotal + -(this.InvoicePartTotal! - this.TotalDeductions);
				}
			} else if (this.PartsTotalAmount > 0) {
				this.FirstEGUIPartsAmount = Math.round((this.paytotal / (this.PaymentTotalAmount! + this.PaymentAdvancePayment!)) * this.PartsTotalAmount);
				if (this.PaymentAdvancePayment! > 0 && this.combinedPartiesSelected[0].CustomerId == this.ZakaznikId) {
					this.TotalFirstEGUIPartsAmount = this.FirstEGUIPartsAmount + this.TotalDeductions + this.PaymentAdvancePayment!;
				} else {
					this.TotalFirstEGUIPartsAmount = this.FirstEGUIPartsAmount + this.TotalDeductions;
				}
				if (this.LaborTotalAmount > 0) {
					if (this.TotalFirstEGUIPartsAmount < 0) {
						this.FirstEGUILaborAmount = Math.round((this.paytotal / (this.PaymentTotalAmount! + this.PaymentAdvancePayment!)) * this.LaborTotalAmount);
						this.FirstEGUILaborAmount -= (-(this.TotalFirstEGUIPartsAmount));
						this.TotalFirstEGUIPartsAmount = 0;
						this.TotalFirstEGUILaborAmount = this.FirstEGUILaborAmount;
					} else {
						this.FirstEGUILaborAmount = this.paytotal - this.FirstEGUIPartsAmount;
						this.TotalFirstEGUILaborAmount = this.FirstEGUILaborAmount;
					}
				}
			} else if (this.LaborTotalAmount > 0) {
				this.FirstEGUILaborAmount = Math.round((this.paytotal / (this.PaymentTotalAmount! + this.PaymentAdvancePayment!)) * this.PartsTotalAmount);
				if (this.PaymentAdvancePayment! > 0 && this.combinedPartiesSelected[0].CustomerId == this.ZakaznikId) {
					this.TotalFirstEGUILaborAmount = this.FirstEGUILaborAmount + this.paytotal + this.TotalDeductions + this.PaymentAdvancePayment!;
				} else {
					this.TotalFirstEGUILaborAmount = this.FirstEGUILaborAmount + this.paytotal + this.TotalDeductions;
				}
			}
		},
		getSecondEGUISplitAmounts() {
			this.SecondEGUILaborAmount = 0;
			this.SecondEGUILaborAmount = 0;
			if (this.PartsTotalAmount <= 0 && this.InvoicePartTotal! > 0 && this.LaborTotalAmount > 0) {
				this.SecondEGUILaborAmount = this.paytotalSecond - this.PartsTotalAmount;
			} else if (this.PartsTotalAmount > 0) {
				if (this.LaborTotalAmount < 0) {
					this.SecondEGUIPartsAmount = this.paytotalSecond;
				}
				else {
					this.SecondEGUIPartsAmount = Math.round((this.paytotalSecond / (this.PaymentTotalAmount! + this.PaymentAdvancePayment!)) * this.PartsTotalAmount);
				}
				if (this.LaborTotalAmount > 0) {
					this.SecondEGUILaborAmount = this.paytotalSecond - this.SecondEGUIPartsAmount;
				}
			} else if (this.LaborTotalAmount > 0) {
				this.SecondEGUILaborAmount = this.paytotalSecond;
			}
		},

		upperCaseValue(field: string, value: string) {
			if (value != null) {
				(this as any)[field] = value.toUpperCase();
			}
		},
		async beforeUnload(event: BeforeUnloadEvent | RouteEvent | null) {
			await this.doBeforeUload(event);
			if (isRouteEvent(event)) {
				let goNext = true;
				if(this.isEGUIEnabled()) {
					goNext = !this.iseGUIIssuePopUpVisible;
				}
				goNext && (await this.handleRemovingFromPageManager(event.to));
				event.next(goNext ? undefined : false);
			}
		},
		async checkEGUIEnabledForInvoicedCustomer() {
			let returnValue = false;
			this.SelectedPartialInvoice = this.combinedSplitParties.filter(x => x.IsSelected && ((!x.IsBilled && (x.OverAllLineItemCompletionStatus || !this.isNotProforma))
				|| (x.IsBilled)));
			if (this.SelectedPartialInvoice[0]?.CustomerId) {
				const { data } = await apiProvider.isCustomerInvoiced(this.ZakazkaId, this.SelectedPartialInvoice[0].CustomerId);
				returnValue = data;

				if (!returnValue) {
					showAlert({
						message: this.LocalizeChyboveHlasky('billingAgain'),
						title: this.LocalizeChyboveHlasky('errorTitle'),
						options: {
							type: 'error',
							closeOnPressEscape: true,
							closeOnClickModal: true,
						},
					});
				}
			}
			return returnValue;
		},
	},
});
